// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  --home-ink: #081925;
  --home-ink-soft: #2e4453;
  --home-sand: #e7f4fb;
  --home-cream: #f4fbff;
  --home-slate: #0b2a3c;
  --home-primary: #0077b6;
  --home-primary-deep: #006199;
  --home-accent: #1fc1d6;
  --home-accent-strong: #35e1f2;
  --home-deep: #082a42;
  --home-shadow: 0 30px 70px rgba(6, 35, 53, 0.22);
  --home-radius: 26px;
}


.home {
  font-family: "Manrope", "Segoe UI", sans-serif;
  color: var(--home-ink);
  background: radial-gradient(circle at top left, #f8fdff 0%, #e2f2ff 50%, #cfe6ff 100%);
  padding-top: var(--home-header-offset, 90px);
  position: relative;
  overflow: hidden;
  --home-hero-grad-start: #090e6f;
  --home-hero-grad-end: #0052b5;
}

body.home-page,
html.home-page {
  scrollbar-width: none;
  scroll-padding-top: var(--home-header-offset, 130px);
}

body.home-page::-webkit-scrollbar,
html.home-page::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.home::before,
.home::after {
  content: "";
  position: absolute;
  width: 480px;
  height: 480px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(31, 193, 214, 0.35), transparent 70%);
  filter: blur(0.5px);
  z-index: 0;
  animation: drift 18s ease-in-out infinite;
}

.home::before {
  top: -120px;
  right: -120px;
}

.home::after {
  bottom: -160px;
  left: -140px;
  animation-delay: 4s;
  background: radial-gradient(circle, rgba(0, 119, 182, 0.3), transparent 70%);
}

@media (max-width: 900px) {
  /* Hide bottom glow on mobile to avoid overlay near the final form */
  .home::after {
    display: none;
  }
}

.home-page #root {
  margin-left: 0 !important;
}

.home-page aside,
.home-page .sidenav---sidenav---_2tBP {
  display: none !important;
}

.home h1,
.home h2,
.home h3,
.home h4,
.home h5 {
  font-family: "Bebas Neue", "Impact", sans-serif;
  margin: 0 0 12px;
}

.home p {
  margin: 0 0 16px;
  color: var(--home-ink-soft);
}

.home-container {
  width: min(1440px, 99%);
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.home-section {
  scroll-margin-top: var(--home-header-offset, 130px);
  position: relative;
  overflow: hidden;
}

.home-section::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(
    circle at 20% 20%,
    rgba(0, 102, 153, 0.45) 0%,
    rgba(0, 102, 153, 0.3) 45%,
    transparent 72%
  );
  opacity: 0;
  transition: opacity 0.6s ease;
  pointer-events: none;
}

.home .dark-gradient-section {
  background: radial-gradient(
    circle at top left,
    var(--home-hero-grad-start) 0%,
    #030628 35%,
    var(--home-hero-grad-end) 100%
  );
}

.home .btn {
  border: none;
  border-radius: 999px;
  padding: 12px 22px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.home .btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
}

.home .btn-primary {
  background: #006699;
  color: #fff;
}

.home .btn-outline {
  background: transparent;
  border: 1px solid #006699;
  color: #006699;
}

.home .btn-ghost {
  background: #fff;
  border: 1px solid rgba(0, 102, 153, 0.35);
  color: #006699;
}

.home-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(244, 251, 255, 0.92);
  backdrop-filter: blur(14px);
  z-index: 50;
  border-bottom: 1px solid rgba(31, 193, 214, 0.22);
}

.home .header-inner {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 14px 0;
}

.home .brand {
  display: flex;
  align-items: center;
  gap: 12px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

.home .brand-mark {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  background: var(--home-primary);
  color: #fff;
  display: grid;
  place-items: center;
  font-weight: 700;
  overflow: hidden;
}

.home .desktop-logo {
  display: block;
  width: 190px;
  height: 100%;
  object-fit: contain;
}

.home .mobile-logo {
  display: none;
}
.home .brand-text {
  display: flex;
  flex-direction: column;
  font-size: 12px;
}

.home .brand-name {
  font-weight: 700;
  font-size: 16px;
  color: var(--home-deep);
}

.home .brand-tag {
  color: var(--home-ink-soft);
}

.home-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  justify-content: center;
  font-size: 14px;
  flex: 1 1 auto;
}

.home-nav a {
  color: var(--home-ink);
  text-decoration: none;
}

.home .header-cta {
  display: flex;
  gap: 12px;
  align-items: center;
}

.home .lang-switch {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: auto;
}

.home .lang-toggle {
  border: 1px solid rgba(31, 193, 214, 0.35);
  background: rgba(255, 255, 255, 0.9);
  color: var(--home-ink);
  border-radius: 999px;
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.home .lang-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: #fff;
  border-radius: 12px;
  border: 1px solid rgba(31, 193, 214, 0.25);
  box-shadow: 0 18px 40px rgba(6, 35, 53, 0.18);
  padding: 8px;
  display: grid;
  gap: 6px;
  z-index: 30;
  min-width: 150px;
}

.home .lang-check {
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  font-weight: 600;
  color: var(--home-ink);
  cursor: pointer;
}

.home .lang-check:hover {
  background: rgba(0, 102, 153, 0.08);
}

.home .lang-check input {
  margin-left: auto;
}

.home .lang-flag {
  width: 18px;
  height: 14px;
  border-radius: 3px;
}

.home .mobile-lang {
  display: grid;
  gap: 8px;
  width: 100%;
}

.home .mobile-lang span {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--home-ink-soft);
}

.home .mobile-lang-actions {
  display: grid;
  gap: 8px;
}

.home .login-dropdown {
  position: relative;
  display: inline-flex;
}

.home .login-dropdown .dropdown-toggle {
  min-width: 120px;
}

.home .dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: #ffffff;
  border: 1px solid rgba(0, 102, 153, 0.2);
  border-radius: 14px;
  box-shadow: 0 16px 32px rgba(6, 35, 53, 0.18);
  padding: 6px;
  display: grid;
  gap: 4px;
  z-index: 70;
  min-width: 180px;
}

.home .dropdown-menu button {
  background: transparent;
  border: none;
  padding: 10px 12px;
  border-radius: 10px;
  text-align: left;
  font-weight: 600;
  color: #0b2a3c;
  cursor: pointer;
}

.home .dropdown-menu button:hover {
  background: rgba(0, 102, 153, 0.08);
}

.home .mobile-cta {
  display: none;
}

.home .menu-toggle {
  display: none;
  background: #fff;
  border: 1px solid rgba(0, 102, 153, 0.2);
  border-radius: 12px;
  padding: 0;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  z-index: 60;
  box-shadow: none;
  line-height: 0;
  font-size: 0;
  outline: none;
  -webkit-tap-highlight-color: transparent;
}

.home .menu-toggle svg {
  width: 22px;
  height: 22px;
  color: var(--home-primary);
  display: block;
  pointer-events: none;
}

.home .menu-toggle:focus-visible {
  outline: 2px solid rgba(0, 102, 153, 0.3);
  outline-offset: 2px;
}

.home .menu-backdrop {
  position: fixed;
  inset: 0;
  background: transparent; /* quitamos el overlay gris al abrir el men� m�vil */
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 40;
}

.home .menu-backdrop.show {
  opacity: 1;
  pointer-events: auto;
}

.home .hero {
  padding: 40px 0 40px;
  position: relative;
  overflow: hidden;
  min-height: auto;
  display: flex;
  align-items: center;
}

.home .hero-media {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
}

.home .hero-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0.7;
  filter: saturate(1.05) contrast(1.05);
}

.home .hero-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.home .video-controls {
  position: static;
  display: flex;
  gap: 8px;
  z-index: 2;
  justify-content: flex-end;
  margin: 12px 0 16px;
}

.home .video-control {
  background: #006699;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  min-height: 30px;
}

.home .video-control:hover {
  background: #005a86;
}

.home .video-control-icon {
  font-size: 14px;
  line-height: 1;
}

.home .visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.home .hero-overlay {
  position: absolute;
  inset: 0;
  background: transparent;
}

.home .hero-grid {
  position: relative;
  z-index: 1;
}

.home .hero-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 36px;
  align-items: center;
}

.home .eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.16em;
  font-size: 12px;
  font-weight: 600;
  color: var(--home-accent);
}

.hero-copy h1,
.hero-copy p,
.home .hero-copy .hero-sub {
  color: #f8fdff;
}

.home .hero-copy .eyebrow {
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
  letter-spacing: 0.2em;
}

.home .hero-copy .hero-sub {
  color: rgba(244, 251, 255, 0.9);
}

.home .hero-sub {
  font-size: 18px;
  max-width: 560px;
  line-height: 1.6;
}

.home .hero-copy h1 {
  font-family: "Manrope", "Segoe UI", sans-serif;
  font-size: clamp(28px, 5vw, 50px);
  line-height: 1.06;
  letter-spacing: -0.01em;
  text-transform: none;
}

.home .hero-copy p {
  font-size: 18px;
}

.home .hero-letter {
  display: inline-block;
  will-change: transform, opacity;
}

.home .hero-cta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 20px 0 18px;
}

.home .hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(7, 16, 26, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(226, 240, 255, 0.92);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  margin-bottom: 18px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.28);
}

.home .hero-badge-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #2ad5a5;
  box-shadow: 0 0 0 4px rgba(42, 213, 165, 0.18);
}

.home .hero-cta .btn-outline {
  border-color: rgba(255, 255, 255, 0.32);
  color: #eaf3ff;
  background: rgba(9, 17, 26, 0.25);
}

.home .hero-cta .btn-ghost {
  border-color: rgba(255, 255, 255, 0.16);
  color: #eaf3ff;
  background: rgba(9, 17, 26, 0.55);
}

.home .hero-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  cursor: none;
}

.home .hero-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(14, 26, 40, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: rgba(226, 240, 255, 0.9);
  font-size: 13px;
  font-weight: 600;
  cursor: default;
}

.home .hero-tag-emoji {
  font-size: 14px;
  line-height: 1;
  cursor: default;
}

.home .hero-highlights {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 16px;
  margin-top: 12px;
}

.home .hero-highlights div {
  background: #fff;
  border-radius: 16px;
  padding: 12px;
  box-shadow: var(--home-shadow);
}

.home .widget-card {
  border: 1px solid rgba(0, 102, 153, 0.28);
  background: linear-gradient(180deg, rgba(0, 102, 153, 0.16) 0%, rgba(0, 102, 153, 0.04) 100%);
  display: grid;
  gap: 8px;
}

.home .widget-value {
  font-size: 22px;
  color: var(--home-primary);
}

.home .widget-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--home-ink-soft);
}

.home .widget-bar {
  height: 6px;
  background: rgba(0, 119, 182, 0.18);
  border-radius: 999px;
  overflow: hidden;
}

.home .widget-bar-fill {
  display: block;
  height: 100%;
  width: 0%;
  background: #006699;
}

.home .hero-visual .mockup {
  background: #fff;
  border-radius: var(--home-radius);
  padding: 24px;
  box-shadow: var(--home-shadow);
  position: relative;
}

.home .mockup-map {
  height: 300px;
  border-radius: 18px;
  background-color: #d8edf5;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  width: 100%;
  display: block;
  object-fit: cover;
}

.home .mockup-video {
  background: #d8edf5;
}

.home .mockup-video-el {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  position: relative;
  z-index: 1;
}

.home .video-overlay {
  position: absolute;
  inset: 0;
  z-index: 2;
  border: none;
  background: linear-gradient(135deg, rgba(0, 38, 68, 0.55), rgba(0, 102, 153, 0.35));
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.2s ease;
  opacity: 0;
  pointer-events: none;
}

.home .mockup-video:hover .video-overlay {
  opacity: 0.92;
  pointer-events: auto;
}

@media (hover: none) {
  .home .video-overlay {
    opacity: 0.92;
    pointer-events: auto;
  }
}

.home .map-route {
  position: absolute;
  inset: 20% 10% 20% 10%;
  border: 2px dashed rgba(0, 102, 153, 0.3);
  border-radius: 18px;
}

.home .map-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--home-accent);
  position: absolute;
  box-shadow: 0 0 0 6px rgba(46, 164, 177, 0.2);
}

.home .dot-1 {
  top: 20%;
  left: 25%;
}

.home .dot-2 {
  top: 55%;
  left: 45%;
}

.home .dot-3 {
  top: 35%;
  left: 70%;
}

.home .mockup-panels {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
  margin: 18px 0;
}

.home .mockup-card {
  background: #f3f8fb;
  border-radius: 16px;
  padding: 14px;
  border: 1px solid rgba(0, 102, 153, 0.12);
  font-size: 13px;
}

.home .mockup-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.home .mockup-card li {
  margin-bottom: 6px;
}

.home .report-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.home .mockup-footer {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: var(--home-ink-soft);
}

.home .trust-bar {
  padding: 28px 0;
  background: #ffffff;
}

.home .trust-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
}

.home .trust-item {
  background: linear-gradient(140deg, #ffffff 0%, #eaf7ff 100%);
  border-radius: 16px;
  padding: 16px;
  border: 1px solid rgba(31, 193, 214, 0.2);
}

.home .trust-sub {
  display: block;
  font-size: 12px;
  color: var(--home-ink-soft);
  margin-top: 4px;
}

.home .trust-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--home-ink-soft);
}

.home .trust-feature {
  margin-top: 32px;
}

.home .trust-feature .section-head h2 {
  color: #0e3048;
}

.home .trust-feature .section-head p {
  color: #2a4c63;
  max-width: 820px;
}

.home .trust-feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-top: 18px;
}

.home .trust-feature-card {
  background: #ffffff;
  border-radius: 18px;
  padding: 18px;
  border: 1px solid rgba(0, 102, 153, 0.14);
  box-shadow: 0 16px 34px rgba(7, 30, 52, 0.08);
  display: grid;
  gap: 10px;
}

.home .trust-feature-card h3 {
  color: #0e3048;
  margin-bottom: 0;
}

.home .trust-feature-card p {
  color: #2a4c63;
  margin: 0;
}

.home .trust-feature-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(0, 102, 153, 0.12);
  display: grid;
  place-items: center;
  font-size: 20px;
}

.home .trust-flow {
  margin-top: 18px;
  background: #0a1433;
  color: #eaf3ff;
  border-radius: 999px;
  padding: 10px 18px;
  text-align: center;
  font-weight: 700;
  letter-spacing: 0.08em;
  border: 1px solid rgba(0, 102, 153, 0.25);
}

.problem-solution,
.modules,
.how-it-works,
.use-cases,
.product-action,
.security-evidence,
.integrations,
.security,
.pricing,
.faq,
.home .final-cta {
  padding: 72px 0;
}

.modules,
.use-cases,
.integrations,
.pricing {
  background: #ffffff;
}

.integrations {
  background: #ffffff;
}

.integrations .home-container {
  background: radial-gradient(
    circle at top left,
    var(--home-hero-grad-start) 0%,
    #030628 35%,
    var(--home-hero-grad-end) 100%
  );
  border-radius: 28px;
  padding: 56px 48px;
}

.integrations .section-head h2 {
  color: #ffffff;
}

.integrations .section-head p {
  color: rgba(230, 243, 255, 0.88);
}

.clients {
  background: #f7fbff;
  padding: 72px 0;
}

.logo-marquee {
  overflow: hidden;
  margin: 20px 0 32px;
}

.logo-track {
  display: flex;
  gap: 36px;
  animation: marquee 18s linear infinite;
}

.logo-track img {
  height: 56px;
  width: 120px;
  object-fit: contain;
  filter: none;
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.testimonials-grid {
  display: none;
}

.testimonials-slider {
  position: relative;
  overflow: hidden;
}

.testimonial-track {
  display: flex;
  width: 100%;
  transition: transform 0.6s ease;
}

.testimonial-slide {
  min-width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 14px;
}

.testimonial-card {
  background: #fff;
  border-radius: 18px;
  padding: 16px;
  border: 1px solid rgba(31, 193, 214, 0.18);
  display: grid;
  gap: 10px;
}

.testimonial-rating {
  color: #f6b73c;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
}

.rating-number {
  color: #0e3048;
}

.testimonial-quote {
  color: #1c3c52;
  line-height: 1.5;
}

.testimonial-footer {
  display: flex;
  justify-content: space-between;
  color: #4a6277;
  font-weight: 600;
}

.testimonial-dots {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 10px;
}

.testimonial-dots .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px solid rgba(31, 193, 214, 0.5);
  background: transparent;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}

.testimonial-dots .dot.active {
  background: #1fc1d6;
  border-color: #1fc1d6;
  transform: scale(1.1);
}

.home .faq {
  background: #ffffff;
  border-top: none;
  margin-top: -2px; /* solapa con la secci�n anterior para ocultar la l�nea */
}

.how-it-works,
.product-action,
.home .security {
  color: #e6f6ff;
  margin-top: -1px; /* elimina l�nea entre secciones oscuras contiguas */
}

.how-it-works .section-head h2,
.product-action .section-head h2,
.home .security .section-head h2 {
  color: #e6f6ff;
}

.how-it-works .section-head p,
.product-action .section-head p,
.home .security .section-head p {
  color: #c5e4ff;
}

.how-it-works .btn,
.product-action .btn,
.home .security .btn {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.35);
}

.how-it-works .btn-outline,
.product-action .btn-outline,
.home .security .btn-outline {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.55);
  background: transparent;
}

.how-it-works .btn-primary,
.product-action .btn-primary,
.home .security .btn-primary {
  background: #1fc1d6;
  color: #061827;
  box-shadow: 0 10px 25px rgba(31, 193, 214, 0.25);
}

.home .section-head {
  margin-bottom: 28px;
}

.home .problem-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}

.home .problem-card {
  background: #fff;
  border-radius: 18px;
  padding: 18px;
  border: 1px solid #eee2d2;
}

.home .solution-banner {
  margin-top: 20px;
  padding: 18px;
  border-radius: 16px;
  background: var(--home-primary);
  color: #fff;
}

.home .module-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 18px;
}

.home .module-card {
  background: #fff;
  border-radius: 20px;
  padding: 20px;
  border: 1px solid rgba(31, 193, 214, 0.18);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.home .module-widget {
  display: grid;
  gap: 10px;
  padding: 12px;
  border-radius: 14px;
  background: #e9f8ff;
  border: 1px solid rgba(31, 193, 214, 0.2);
}

.home .module-bar {
  height: 8px;
  background: rgba(0, 119, 182, 0.2);
  border-radius: 999px;
  overflow: hidden;
}

.home .module-bar-fill {
  display: block;
  height: 100%;
  width: 0%;
  background: linear-gradient(90deg, var(--home-primary), var(--home-accent));
}

.home .module-card ul {
  margin: 0;
  padding-left: 18px;
  color: var(--home-ink-soft);
}

.home .link-btn {
  margin-top: auto;
  background: none;
  border: none;
  color: var(--home-primary);
  font-weight: 600;
  cursor: pointer;
}

.home .steps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}

.home .step-card {
  background: #fff;
  border-radius: 20px;
  padding: 20px;
  border: 1px solid rgba(31, 193, 214, 0.18);
}

.home .step-index {
  font-weight: 700;
  color: var(--home-accent);
}

.home .usecase-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 18px;
}

.home .usecase-card {
  background: #fff;
  border-radius: 20px;
  padding: 20px;
  border: 1px solid rgba(31, 193, 214, 0.18);
  display: grid;
  gap: 12px;
}

.home .usecase-row {
  display: grid;
  gap: 4px;
  font-size: 14px;
}

.home .product-action .tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 24px;
}

.home .tab-btn {
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  padding: 8px 18px;
  cursor: pointer;
  font-weight: 600;
  color: #e6f6ff;
}

.home .tab-btn.active {
  background: #1fc1d6;
  color: #061827;
  border-color: transparent;
  box-shadow: 0 8px 18px rgba(31, 193, 214, 0.32);
}

.home .tab-panel {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(360px, 1.25fr);
  gap: 24px;
  align-items: start;
}

.home .product-action .tab-copy h3 {
  color: #e6f6ff;
}

.home .product-action .tab-copy p,
.home .product-action .tab-copy li {
  color: #c5e4ff;
}

.home .product-action .btn-outline {
  border-color: rgba(255, 255, 255, 0.5);
  color: #fff;
}

.home .tab-panel ul {
  padding-left: 18px;
}

.home .tab-visual {
  display: grid;
  gap: 16px;
  align-content: start;
}

.home .panel-preview {
  background: linear-gradient(135deg, #ffffff 0%, #eef7ff 50%, #e3f1ff 100%);
  border-radius: 20px;
  padding: 18px;
  border: 1px solid rgba(31, 193, 214, 0.18);
  width: 100%;
}

@media (max-width: 980px) {
  .home .tab-panel {
    grid-template-columns: 1fr;
  }
}

.home .panel-header {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #3b5368;
  font-weight: 700;
}

.home .panel-body {
  display: grid;
  gap: 10px;
  margin-top: 14px;
  position: relative;
}

.home .panel-video {
  width: 100%;
  border-radius: 14px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.08);
  background: #000;
  object-fit: cover;
}

.panel-skeleton {
  position: absolute;
  inset: 0;
  display: grid;
  gap: 10px;
  padding: 16px;
  background: linear-gradient(135deg, #eef7ff 0%, #e3f1ff 100%);
  border-radius: 14px;
  z-index: 1;
}

.home .panel-line {
  height: 12px;
  background: #bcdaf5;
  border-radius: 999px;
}

.home .panel-line.short {
  width: 70%;
}

.home .panel-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 12px;
}

.home .panel-metrics div {
  background: #ffffff;
  border-radius: 16px;
  padding: 14px;
  border: 1px solid rgba(31, 193, 214, 0.18);
  text-align: center;
  color: #0e3048;
  font-weight: 700;
}

.home .panel-metrics div span {
  display: block;
  margin-top: 4px;
  color: #1c3c52;
  font-weight: 600;
}

.home .integration-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 18px;
}

.home .integration-card {
  background: #fff;
  border-radius: 20px;
  padding: 20px;
  border: 1px solid rgba(31, 193, 214, 0.18);
}

.home .integration-card ul {
  padding-left: 18px;
}

.home .integrations-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 22px;
  margin-top: 26px;
}

.home .integration-panel {
  background: #ffffff;
  border-radius: 22px;
  padding: 22px;
  border: 1px solid rgba(14, 48, 72, 0.12);
  box-shadow: 0 18px 40px rgba(10, 35, 55, 0.12);
}

.home .integration-panel h3 {
  color: #0e3048;
  margin-bottom: 14px;
}

.home .integration-panel ul {
  margin: 12px 0 0;
  padding-left: 20px;
  color: #22455f;
}

.home .integration-panel li {
  margin-bottom: 8px;
}

.home .integration-highlight {
  background: linear-gradient(135deg, rgba(214, 245, 251, 0.9), rgba(232, 248, 255, 0.65));
  border-radius: 16px;
  padding: 14px 16px;
  border: 1px solid rgba(31, 193, 214, 0.28);
  margin-bottom: 16px;
  color: #0c3348;
  box-shadow: inset 0 0 24px rgba(31, 193, 214, 0.12);
}

.home .integration-highlight h4 {
  margin-bottom: 6px;
  color: #0e3048;
  font-size: 16px;
}

.home .integration-highlight p {
  margin: 0;
  color: #24506b;
}

.home .security-evidence {
  background: #f7fbff;
  color: #0b2a3c;
}

.home .evidence-head h2 {
  color: #0e3048;
  font-weight: 700;
}

.home .evidence-head p {
  color: #2e4453;
  max-width: 860px;
}

.home .evidence-steps {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 18px;
  padding: 12px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid rgba(0, 102, 153, 0.16);
}

.home .evidence-step {
  background: #f2f7fb;
  border: 1px solid rgba(0, 102, 153, 0.14);
  color: #0e3048;
  padding: 8px 14px;
  border-radius: 999px;
  font-weight: 600;
  cursor: default;
}

.home .evidence-step.active {
  background: linear-gradient(135deg, rgba(31, 193, 214, 0.25), rgba(31, 193, 214, 0.12));
  border-color: rgba(31, 193, 214, 0.6);
  color: #083044;
}

.home .evidence-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 12px;
  color: #2e4a5f;
  font-weight: 600;
  font-size: 13px;
  text-transform: lowercase;
}

.home .evidence-meta span {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.home .evidence-meta span::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #43c7da;
  box-shadow: 0 0 8px rgba(67, 199, 218, 0.6);
}

.home .evidence-panels {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 18px;
  margin-top: 18px;
}

.home .evidence-panel {
  background: #ffffff;
  border-radius: 18px;
  padding: 18px;
  border: 1px dashed rgba(0, 102, 153, 0.18);
  box-shadow: 0 16px 32px rgba(6, 35, 53, 0.08);
}

.home .evidence-panel h4 {
  color: #0e3048;
  margin-bottom: 12px;
  font-size: 14px;
}

.home .evidence-placeholder {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 12px;
  background: repeating-linear-gradient(
    90deg,
    rgba(206, 224, 238, 0.6),
    rgba(206, 224, 238, 0.6) 10px,
    rgba(224, 238, 248, 0.6) 10px,
    rgba(224, 238, 248, 0.6) 20px
  );
  border: 1px solid rgba(0, 102, 153, 0.16);
}

.home .world-section {
  padding: 88px 0 90px;
  position: relative;
  overflow: hidden;
  color: #e6f6ff;
  margin-bottom: -1px; /* solapa con la siguiente secci�n para evitar l�neas visibles */
}

.home .world-section::before {
  content: "";
  position: absolute;
  width: 620px;
  height: 620px;
  border-radius: 50%;
  right: -220px;
  top: -220px;
  background: radial-gradient(circle, rgba(31, 193, 214, 0.18), transparent 70%);
  z-index: 0;
}

.home .world-layout {
  display: flex;
  gap: 18px;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: nowrap;
}

.home .world-right .section-head {
  margin-bottom: 18px;
}

.home .world-right {
  width: 100%;
}

.home .gps-animated-text {
  max-width: 460px;
}

.home .world-panel {
  position: relative;
  z-index: 1;
}

.home .globe-stage {
  position: relative;
  flex: 0 0 560px;
  min-width: 0;
  transform-style: preserve-3d;
  transition: transform 0.2s ease;
  width: min(640px, 100%);
}

.home .globe-wrapper {
  position: relative;
  height: 460px;
  min-height: 460px;
  width: 100%;
  border-radius: 0;
  background: transparent;
  overflow: visible;
  transform-origin: center;
  transform-style: preserve-3d;
  display: flex;
  align-items: center;  
}

.home .globe-canvas {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  inset: 0;
  z-index: 1;
  background: transparent;
}

.home .globe-image {
  width: auto;
  height: 100%;
  display: block;
  position: absolute;
  inset: 0;
  z-index: 1;
  border-radius: 24px;
  align-self: center;
}

.home .globe-overlay {
  position: absolute;
  inset: 0;
  background-image: none;
  opacity: 0;
  z-index: 2;
  pointer-events: none;
}

.home .globe-glow {
  position: absolute;
  inset: 0;
  background: none;
  pointer-events: none;
  z-index: 3;
}

.home .globe-darken {
  position: absolute;
  inset: 0;
  background: transparent;
  z-index: 0;
  pointer-events: none;
}

.home .brand-orbit {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 6;
}

.home .brand-chip {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(7, 30, 46, 0.75);
  border: 1px solid rgba(49, 200, 224, 0.45);
  color: #e8f7ff;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.02em;
  box-shadow: 0 10px 20px rgba(2, 12, 22, 0.35);
  backdrop-filter: blur(6px);
  pointer-events: auto;
  transition: transform 0.2s ease, opacity 0.2s ease, box-shadow 0.2s ease;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.home .brand-chip:hover {
  box-shadow: 0 14px 26px rgba(2, 12, 22, 0.45);
  border-color: rgba(53, 225, 242, 0.8);
}

.home .brand-chip img {
  width: 48px;
  height: 24px;
  object-fit: contain;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.35));
}

.home .brand-tooltip {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 10px);
  transform: translate(-50%, 6px);
  background: rgba(5, 18, 28, 0.95);
  color: #e8f7ff;
  padding: 8px 10px;
  border-radius: 10px;
  border: 1px solid rgba(49, 200, 224, 0.4);
  font-size: 11px;
  line-height: 1.2;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
  width: max-content;
  max-width: 180px;
  text-align: center;
  z-index: 2;
}

.brand-chip.is-active .brand-tooltip,
.home .brand-chip:hover .brand-tooltip {
  opacity: 1;
  transform: translate(-50%, 0);
}

.home .gps-animated-text {
  flex: 0 0 340px;
  max-width: 420px;
  background: transparent;
  border-radius: 0;
  padding: 0;
  border: none;
  display: grid;
  gap: 16px;
  color: #e6f6ff;
  box-shadow: none;
}

.home .gps-animated-text h3 {
  margin: 0;
  font-size: 28px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  line-height: 1.05;
  color: #ffffff;
  animation: headlinePulse 2.8s ease-in-out infinite;
}

.home .gps-animated-text p {
  margin: 0;
  color: rgba(230, 246, 255, 0.8);
  font-size: 15px;
  line-height: 1.5;
  animation: copyFloat 6s ease-in-out infinite;
}

.home .gps-kicker {
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 12px;
  font-weight: 700;
  color: #8fe9ff;
  animation: kickerGlow 3.2s ease-in-out infinite;
}

.home .gps-pill-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  list-style: disc;
  list-style-position: outside;
  padding-left: 18px;
  margin: 0;
}

.home .gps-pill-row li {
  background: transparent;
  border: 0;
  padding: 0;
  border-radius: 0;
  font-size: 12px;
  font-weight: 600;
  text-align: left;
}

.home .world-right {
  flex: 1 1;
  display: grid;
  gap: 16px;
  min-width: 0;
}

.home .world-map-row {
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-around;
  align-content: center;
}

.home .world-mobile-grid {
  display: none;
}

.home .world-mobile-card {
  display: grid;
  grid-template-columns: 56px 1fr;
  gap: 12px;
  align-items: center;
  padding: 14px 16px;
  border-radius: 18px;
  border: 1px solid rgba(31, 193, 214, 0.35);
  background: rgba(7, 30, 46, 0.6);
  color: #e6f6ff;
}

.home .world-mobile-card img {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  object-fit: contain;
  background: rgba(255, 255, 255, 0.92);
  padding: 6px;
}

.home .world-mobile-card strong {
  display: block;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.home .world-mobile-card span {
  font-size: 12px;
  color: rgba(230, 246, 255, 0.7);
}

@media (max-width: 1200px) {
.home .world-layout {
    gap: 20px;
  }

.home .gps-animated-text {
    flex: 0 0 300px;
    max-width: 320px;
  }
}

@media (max-width: 1024px) {
.home .world-layout {
    flex-direction: column;
    align-items: stretch;
  }

.home .world-map-row {
    flex-direction: column;
    align-items: center;
  }

.home .globe-stage {
    width: auto;
    max-width: 560px;
    justify-content: center;
    height: auto;
    flex: 0 0 auto;
  }

.home .gps-animated-text {
    max-width: 100%;
    flex: 1 1 auto;
    text-align: center;
  }

.home .gps-animated-text h3 {
    font-size: 24px;
  }

.home .gps-animated-text p {
    font-size: 14px;
  }

.home .gps-pill-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    justify-items: center;
  }

.home .globe-wrapper {
    height: 360px;
  }

.home .brand-orbit {
    position: static;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
    margin-top: 12px;
  }

.home .brand-chip {
    position: static;
    transform: none !important;
  }
}

@media (max-width: 768px) {
.home .world-map-row {
    gap: 16px;
  }

.home .globe-wrapper {
    height: clamp(220px, 55vw, 280px);
    min-height: clamp(220px, 55vw, 280px);
  }

.home .globe-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

.home .gps-pill-row {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
.home .globe-wrapper {
    height: clamp(200px, 60vw, 240px);
    min-height: clamp(200px, 60vw, 240px);
  }
}

.home .world-right {
  width: 100%;
}

.home .world-left {
  flex: 0 0 380px;
  max-width: 420px;
}

.home .world-panel-right {
  background: linear-gradient(160deg, #0b3e5f 0%, #07304b 60%, #062538 100%);
  color: #fff;
  border-radius: 28px;
  padding: 24px;
  border: 1px solid rgba(31, 193, 214, 0.35);
  display: grid;
  gap: 16px;
}

.home .world-panel-right p {
  color: rgba(255, 255, 255, 0.72);
}

.home .world-panel-right ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 10px;
}

.home .world-panel-right li {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(31, 193, 214, 0.35);
  padding: 10px 12px;
  border-radius: 14px;
  font-weight: 600;
}

.home .world-panel-right .btn-outline {
  border-color: rgba(255, 255, 255, 0.5);
  color: #fff;
}

.home .security-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.home .security-card {
  background: #fff;
  border-radius: 18px;
  padding: 18px;
  border: 1px solid rgba(31, 193, 214, 0.18);
}

.home .pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 18px;
}

.home .price-card {
  background: #f9fcff;
  border-radius: 20px;
  padding: 22px;
  border: 1px solid rgba(31, 193, 214, 0.18);
  display: grid;
  gap: 12px;
}

.home .price-card.featured {
  background: linear-gradient(135deg, #0a2a3f 0%, #0d5278 45%, #0b6c9c 100%);
  color: #eaf6ff;
}

.price-card.featured p,
.home .price-card.featured li {
  color: #d8ecff;
}

.home .price-card .btn {
  border: 1px solid var(--home-primary);
  color: var(--home-primary);
  background: transparent;
}

.home .price-card .btn-primary {
  background: var(--home-primary);
  color: #fff;
  border-color: transparent;
}

.home .price-card.featured .btn-primary,
.home .price-card.featured .btn {
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.35);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.home .price-card h3 {
  color: #0e3048;
}

.home .price-card.featured h3 {
  color: #ffffff;
}

.home .price-card.featured .price-tag {
  color: #ffffff;
  opacity: 0.96;
}

.home .price-card p,
.home .price-card li {
  color: #1c3c52;
}

.home .price-tag {
  font-weight: 600;
}

.home .price-card ul {
  padding-left: 18px;
}

.home .faq-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 18px;
}

.home .faq-item {
  background: #fff;
  border-radius: 18px;
  padding: 18px;
  border: 1px solid rgba(31, 193, 214, 0.18);
}

.home .final-cta {
  background: #ffffff;
}

.home .final-cta::after {
  /* Remove the generic section glow that covers inputs on small screens */
  display: none;
}

.home-footer {
  background: linear-gradient(135deg, #ffffff 0%, #f4fbff 60%, #e9f6ff 100%);
  border-top: 1px solid rgba(31, 193, 214, 0.12);
  padding: 26px 0;
}

.footer-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: var(--home-ink-soft);
}

.footer-brand {
  font-weight: 700;
  color: var(--home-primary);
}

.footer-legal {
  opacity: 0.85;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: center;
  color: var(--home-ink-soft);
}

.footer-links button {
  background: none;
  border: none;
  padding: 0;
  color: var(--home-ink-soft);
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.footer-links button:hover {
  color: var(--home-primary);
}

@media (max-width: 640px) {
  .footer-inner {
    flex-direction: column;
    text-align: center;
  }
}

.home .final-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 28px;
  align-items: center;
}

.home .final-list {
  display: grid;
  gap: 8px;
  font-weight: 600;
}

.home .final-form {
  display: grid;
  gap: 12px;
  background: #fff;
  padding: 22px;
  border-radius: 20px;
  border: 1px solid rgba(31, 193, 214, 0.18);
}

.home .final-form label {
  display: grid;
  gap: 6px;
  font-weight: 600;
  font-size: 14px;
}

.home .final-form input {
  border-radius: 10px;
  border: 1px solid rgba(31, 193, 214, 0.3);
  padding: 10px;
  font-size: 14px;
}

.home .final-form select {
  border-radius: 10px;
  border: 1px solid rgba(31, 193, 214, 0.3);
  padding: 10px;
  font-size: 14px;
  background: #fff;
  color: var(--home-ink);
}

.home .final-form textarea,
.home .message-input {
  width: 100%;
  border-radius: 10px;
  border: 1px solid rgba(31, 193, 214, 0.3);
  padding: 10px 12px;
  font-size: 14px;
  font-family: inherit;
  color: var(--home-ink);
  background: #fff;
  line-height: 1.4;
  resize: vertical;
  box-sizing: border-box;
}

.home .final-form input:focus,
.home .final-form select:focus,
.home .final-form textarea:focus,
.home .message-input:focus,
.home .phone-input:focus,
.home .country-select__control--is-focused {
  outline: none;
  border-color: rgba(0, 102, 153, 0.55);
  box-shadow: 0 0 0 3px rgba(0, 119, 182, 0.18);
}

.home .country-select {
  font-size: 14px;
}

.home .country-select__control {
  border-radius: 10px !important;
  border: 1px solid rgba(31, 193, 214, 0.3) !important;
  box-shadow: none !important;
  min-height: 42px !important;
  background: #fff !important;
}

.home .country-select__control:hover {
  border-color: rgba(0, 102, 153, 0.55) !important;
}

.home .country-select__value-container {
  padding: 2px 10px !important;
}

.home .country-select__single-value {
  color: var(--home-ink) !important;
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
}

.home .country-select__menu {
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid rgba(31, 193, 214, 0.25);
  box-shadow: 0 18px 40px rgba(6, 35, 53, 0.18);
  z-index: 30;
}

.home .country-select__option {
  font-size: 14px;
}

.home .country-select__indicator-separator {
  display: none;
}

.home .country-option {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.home .country-flag {
  width: 20px;
  height: 16px;
  border-radius: 3px;
  box-shadow: 0 2px 6px rgba(6, 35, 53, 0.2);
}

.home .country-name {
  color: var(--home-ink);
}

.home .phone-container {
  width: 100%;
}

.home .phone-input {
  width: 100% !important;
  border-radius: 10px !important;
  border: 1px solid rgba(31, 193, 214, 0.3) !important;
  padding: 10px 12px 10px 48px !important;
  font-size: 14px !important;
  height: 42px !important;
  box-shadow: none !important;
}

.home .phone-flag {
  border-radius: 10px 0 0 10px !important;
  border: 1px solid rgba(31, 193, 214, 0.3) !important;
  background: #fff !important;
}

.home .phone-dropdown {
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid rgba(31, 193, 214, 0.25) !important;
  box-shadow: 0 18px 40px rgba(6, 35, 53, 0.18) !important;
}

.home .anim-section,
.home .anim-card,
.home .anim-hero,
.home .anim-visual {
  will-change: transform, opacity;
}

.home .animate-up {
  animation: fadeUp 0.7s ease both;
}

.home .card-animated {
  position: relative;
  overflow: hidden;
  animation: cardRise 0.6s ease both;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.home .card-animated::before {
  content: none;
}

.home .card-animated::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    120deg,
    transparent 0%,
    rgba(0, 102, 153, 0.28) 45%,
    rgba(0, 102, 153, 0.18) 70%,
    transparent 100%
  );
  transform: translateX(-100%);
  transition: transform 0.8s ease;
}

.home .card-animated:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 30px rgba(0, 102, 153, 0.18);
}

.home .card-animated:hover::after {
  transform: translateX(100%);
}

.home .float {
  animation: float 5s ease-in-out infinite;
}

.home .floating-nav {
  position: fixed;
  right: 24px;
  bottom: 24px;
  display: grid;
  gap: 12px;
  z-index: 60;
}

.home .nav-btn {
  border: 1px solid rgba(31, 193, 214, 0.3);
  background: #fff;
  color: var(--home-primary);
  border-radius: 999px;
  padding: 10px 18px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.home .nav-btn.icon {
  width: 46px;
  height: 46px;
  padding: 0;
  display: grid;
  place-items: center;
  font-size: 18px;
}

.home .nav-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
}

.home .nav-btn.primary {
  background: linear-gradient(135deg, var(--home-primary), var(--home-accent));
  color: #fff;
  border-color: transparent;
}

.home .module-grid > .card-animated:nth-child(1) { animation-delay: 0.05s; }
.home .module-grid > .card-animated:nth-child(2) { animation-delay: 0.1s; }
.home .module-grid > .card-animated:nth-child(3) { animation-delay: 0.15s; }
.home .module-grid > .card-animated:nth-child(4) { animation-delay: 0.2s; }
.home .module-grid > .card-animated:nth-child(5) { animation-delay: 0.25s; }
.home .module-grid > .card-animated:nth-child(6) { animation-delay: 0.3s; }

.home .usecase-grid > .card-animated:nth-child(odd),
.home .pricing-grid > .card-animated:nth-child(odd),
.home .faq-grid > .card-animated:nth-child(odd) {
  animation-delay: 0.08s;
}



@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes cardRise {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes drift {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(40px, -20px);
  }
}

@keyframes headlinePulse {
  0%, 100% {
    text-shadow: 0 0 0 rgba(143, 233, 255, 0);
    transform: translateY(0);
  }
  50% {
    text-shadow: 0 12px 30px rgba(143, 233, 255, 0.25);
    transform: translateY(-2px);
  }
}

@keyframes copyFloat {
  0%, 100% {
    transform: translateY(0);
    opacity: 0.9;
  }
  50% {
    transform: translateY(3px);
    opacity: 1;
  }
}

@keyframes kickerGlow {
  0%, 100% {
    opacity: 0.85;
  }
  50% {
    opacity: 1;
    text-shadow: 0 0 16px rgba(143, 233, 255, 0.45);
  }
}

@media (max-width: 900px) {
.home .globe-stage {
    order: 1;
  }

.home .gps-animated-text {
    order: 2;
    max-width: 100%;
  }

.home .globe-stage {
    display: block;
    width: 100%;
    max-width: 560px;
    margin: 0 auto 18px;
  }

.home .world-section {
    padding: 60px 0 72px;
  }

.home .world-layout {
    gap: 24px;
    align-items: center;
  }

.home .world-mobile-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 14px;
    margin-top: 18px;
  }

.home .world-mobile-card {
    grid-template-columns: 1fr;
    justify-items: center;
    text-align: center;
    padding: 16px;
  }

.home .world-mobile-card div {
    display: none;
  }

  .world-left,
.home .world-right {
    max-width: 100%;
    flex: 1 1 auto;
  }
.home-header {
    position: fixed;
  }

.home .header-inner {
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 12px;
    padding: 10px 0;
  }

.home .menu-toggle {
    justify-self: end;
    margin-left: auto;
  }

.home .lang-switch {
    display: none;
  }

.home {
    padding-top: var(--home-header-offset, 90px);
  }

.home-nav {
    position: fixed;
    top: calc(var(--home-header-offset, 130px));
    right: 16px;
    left: 16px;
    background: #fff;
    border-radius: 18px;
    padding: 18px 16px;
    box-shadow: 0 24px 60px rgba(7, 36, 53, 0.18);
    flex-direction: column;
    gap: 14px;
    align-items: flex-start;
    opacity: 0;
    transform: translateY(-10px);
    pointer-events: none;
    transition: opacity 0.2s ease, transform 0.2s ease;
    z-index: 55;
  }

.home-nav.open {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  }

.home .header-cta {
    display: none;
  }

.home .mobile-cta {
    display: grid;
    gap: 10px;
    width: 100%;
    padding-top: 4px;
    border-top: 1px solid rgba(0, 102, 153, 0.12);
    box-sizing: border-box;
  }

.home .mobile-cta .btn {
    width: 100%;
    justify-content: center;
    box-sizing: border-box;
    max-width: 100%;
  }

.home .menu-toggle {
    display: inline-flex;
  }

.home .brand-text {
    line-height: 1.2;
  }

.home .desktop-logo {
    display: none;
  }

.home .mobile-logo {
    width: 180px;
    display: block;
  }

.home .hero-grid {
    grid-template-columns: 1fr;
  }

.home .hero-cta {
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
  }

.home .hero-visual .mockup {
    padding: 18px;
  }

.home .mockup-panels {
    grid-template-columns: 1fr;
  }

.home .hero-highlights {
    grid-template-columns: repeat(2, minmax(120px, 1fr));
  }

.home .globe-wrapper {
    height: 340px;
  }

.home .world-left {
    order: 2;
  }

.home .floating-nav {
    right: 16px;
    bottom: 16px;
    gap: 10px;
  }
}

@media (max-width: 900px) {
  .home .globe-wrapper {
    height: auto;
    min-height: 0;
    aspect-ratio: 16 / 9;
    align-items: center;
    justify-content: center;
  }

  .home .globe-image {
    position: relative;
    width: 100%;
    height: auto;
    max-height: 360px;
    object-fit: contain;
  }
}

@media (max-width: 680px) {
.home .home-container {
    padding-left: 16px;
    padding-right: 16px;
  }

.home .header-cta {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

.home .hero {
    padding-top: 60px;
  }

.home .hero-highlights {
    grid-template-columns: 1fr;
  }

.home .hero-cta {
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 0;
    box-sizing: border-box;
  }

.home .globe-wrapper {
    height: auto;
    min-height: 0;
    aspect-ratio: 16 / 9;
  }

.home .gps-pill-row {
    grid-template-columns: 1fr;
  }


.home .hero-cta .btn {
    width: 100%;
    text-align: center;
  }

.home .hero-cta .btn {
    max-width: 100%;
    margin: 0;
    box-sizing: border-box;
  }
}

/* Splash screen */
.splash-screen {
  position: fixed;
  inset: 0;
  background: radial-gradient(circle at 30% 30%, #0a2a3f 0%, #051a2a 55%, #041424 100%);
  display: grid;
  place-items: center;
  z-index: 9999;
  animation: splashFade 0.7s ease 2.4s forwards;
}

.splash-logo {
  width: min(360px, 70vw);
  animation: splashIn 1.2s ease both;
}

@keyframes splashIn {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes splashFade {
  to {
    opacity: 0;
    visibility: hidden;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/home.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,gDAAgD;EAChD,mBAAmB;AACrB;;;AAGA;EACE,8CAA8C;EAC9C,sBAAsB;EACtB,sFAAsF;EACtF,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;;EAEE,QAAQ;EACR,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,8EAA8E;EAC9E,mBAAmB;EACnB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,oEAAoE;EACpE;IACE,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;;;EAKE,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mDAAmD;EACnD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,qCAAqC;EACrC,2BAA2B;EAC3B,WAAW;EACX,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,uBAAuB,EAAE,oDAAoD;EAC7E,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,iCAAiC;EACjC,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,iCAAiC;EACjC,2CAA2C;EAC3C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,iCAAiC;EACjC,2CAA2C;EAC3C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,6FAA6F;EAC7F,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mFAAmF;EACnF,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;IACb,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,6CAA6C;EAC7C,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;;;;;;;;;;;EAWE,eAAe;AACjB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;;;;GAKC;EACD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,uBAAuB;EACvB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB,EAAE,yDAAyD;AAC7E;;AAEA;;;EAGE,cAAc;EACd,gBAAgB,EAAE,oDAAoD;AACxE;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,uCAAuC;AACzC;;AAEA;;;EAGE,WAAW;EACX,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,2EAA2E;AAC7E;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,+DAA+D;EAC/D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,0EAA0E;EAC1E,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,SAAS;EACT,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wFAAwF;EACxF,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uFAAuF;EACvF,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB;;;;;;GAMC;EACD,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB,EAAE,gEAAgE;AACvF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,8EAA8E;EAC9E,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,UAAU;EACV,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;EACpB,iCAAiC;EACjC,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,6CAA6C;EAC7C,0BAA0B;EAC1B,oBAAoB;EACpB,wEAAwE;EACxE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,+BAA+B;EAC/B,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAW;EACX,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;AACA;IACI,SAAS;EACX;;AAEF;IACI,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;AACA;IACI,sBAAsB;IACtB,oBAAoB;EACtB;;AAEF;IACI,sBAAsB;IACtB,mBAAmB;EACrB;;AAEF;IACI,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,cAAc;EAChB;;AAEF;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;AAEF;IACI,eAAe;EACjB;;AAEF;IACI,eAAe;EACjB;;AAEF;IACI,gDAAgD;IAChD,qBAAqB;EACvB;;AAEF;IACI,aAAa;EACf;;AAEF;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,gBAAgB;EAClB;;AAEF;IACI,gBAAgB;IAChB,0BAA0B;EAC5B;AACF;;AAEA;AACA;IACI,SAAS;EACX;;AAEF;IACI,iCAAiC;IACjC,qCAAqC;EACvC;;AAEF;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;AAEF;IACI,0BAA0B;EAC5B;AACF;;AAEA;AACA;IACI,iCAAiC;IACjC,qCAAqC;EACvC;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0EAA0E;EAC1E,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,SAAS;AACX;;AAEA;EACE,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;EACd,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wEAAwE;EACxE,aAAa;AACf;;AAEA;EACE,0EAA0E;EAC1E,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;;;EAME,aAAa;EACb,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,oDAAoD;EACpD,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0CAA0C;EAC1C,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,oDAAoD;EACpD,uCAAuC;EACvC,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,qDAAqD;EACrD,wDAAwD;AAC1D;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,uDAAuD;AACzD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;;GAMC;EACD,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,4EAA4E;EAC5E,WAAW;EACX,yBAAyB;AAC3B;;AAEA,mDAAmD,sBAAsB,EAAE;AAC3E,mDAAmD,qBAAqB,EAAE;AAC1E,mDAAmD,sBAAsB,EAAE;AAC3E,mDAAmD,qBAAqB,EAAE;AAC1E,mDAAmD,sBAAsB,EAAE;AAC3E,mDAAmD,qBAAqB,EAAE;;AAE1E;;;EAGE,sBAAsB;AACxB;;;;AAIA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,yCAAyC;IACzC,wBAAwB;EAC1B;EACA;IACE,kDAAkD;IAClD,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,+CAA+C;EACjD;AACF;;AAEA;AACA;IACI,QAAQ;EACV;;AAEF;IACI,QAAQ;IACR,eAAe;EACjB;;AAEF;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;AAEF;IACI,oBAAoB;EACtB;;AAEF;IACI,SAAS;IACT,mBAAmB;EACrB;;AAEF;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;EAClB;;AAEF;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;EACf;;AAEF;IACI,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,cAAc;EAChB;AACF;IACI,eAAe;EACjB;;AAEF;IACI,oCAAoC;IACpC,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;AAEF;IACI,iBAAiB;IACjB,iBAAiB;EACnB;;AAEF;IACI,aAAa;EACf;;AAEF;IACI,4CAA4C;EAC9C;;AAEF;IACI,eAAe;IACf,2CAA2C;IAC3C,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,6CAA6C;IAC7C,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,UAAU;IACV,4BAA4B;IAC5B,oBAAoB;IACpB,kDAAkD;IAClD,WAAW;EACb;;AAEF;IACI,UAAU;IACV,wBAAwB;IACxB,oBAAoB;EACtB;;AAEF;IACI,aAAa;EACf;;AAEF;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,6CAA6C;IAC7C,sBAAsB;EACxB;;AAEF;IACI,WAAW;IACX,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;EACjB;;AAEF;IACI,oBAAoB;EACtB;;AAEF;IACI,gBAAgB;EAClB;;AAEF;IACI,aAAa;EACf;;AAEF;IACI,YAAY;IACZ,cAAc;EAChB;;AAEF;IACI,0BAA0B;EAC5B;;AAEF;IACI,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;EACrB;;AAEF;IACI,aAAa;EACf;;AAEF;IACI,0BAA0B;EAC5B;;AAEF;IACI,oDAAoD;EACtD;;AAEF;IACI,aAAa;EACf;;AAEF;IACI,QAAQ;EACV;;AAEF;IACI,WAAW;IACX,YAAY;IACZ,SAAS;EACX;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;AACA;IACI,kBAAkB;IAClB,mBAAmB;EACrB;;AAEF;IACI,WAAW;IACX,2BAA2B;IAC3B,eAAe;EACjB;;AAEF;IACI,iBAAiB;EACnB;;AAEF;IACI,0BAA0B;EAC5B;;AAEF;IACI,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,UAAU;IACV,sBAAsB;EACxB;;AAEF;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;EACtB;;AAEF;IACI,0BAA0B;EAC5B;;;AAGF;IACI,WAAW;IACX,kBAAkB;EACpB;;AAEF;IACI,eAAe;IACf,SAAS;IACT,sBAAsB;EACxB;AACF;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,qFAAqF;EACrF,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;AACF","sourcesContent":[".home {\n  --home-ink: #081925;\n  --home-ink-soft: #2e4453;\n  --home-sand: #e7f4fb;\n  --home-cream: #f4fbff;\n  --home-slate: #0b2a3c;\n  --home-primary: #0077b6;\n  --home-primary-deep: #006199;\n  --home-accent: #1fc1d6;\n  --home-accent-strong: #35e1f2;\n  --home-deep: #082a42;\n  --home-shadow: 0 30px 70px rgba(6, 35, 53, 0.22);\n  --home-radius: 26px;\n}\n\n\n.home {\n  font-family: \"Manrope\", \"Segoe UI\", sans-serif;\n  color: var(--home-ink);\n  background: radial-gradient(circle at top left, #f8fdff 0%, #e2f2ff 50%, #cfe6ff 100%);\n  padding-top: var(--home-header-offset, 90px);\n  position: relative;\n  overflow: hidden;\n  --home-hero-grad-start: #090e6f;\n  --home-hero-grad-end: #0052b5;\n}\n\nbody.home-page,\nhtml.home-page {\n  scrollbar-width: none;\n  scroll-padding-top: var(--home-header-offset, 130px);\n}\n\nbody.home-page::-webkit-scrollbar,\nhtml.home-page::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.home::before,\n.home::after {\n  content: \"\";\n  position: absolute;\n  width: 480px;\n  height: 480px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(31, 193, 214, 0.35), transparent 70%);\n  filter: blur(0.5px);\n  z-index: 0;\n  animation: drift 18s ease-in-out infinite;\n}\n\n.home::before {\n  top: -120px;\n  right: -120px;\n}\n\n.home::after {\n  bottom: -160px;\n  left: -140px;\n  animation-delay: 4s;\n  background: radial-gradient(circle, rgba(0, 119, 182, 0.3), transparent 70%);\n}\n\n@media (max-width: 900px) {\n  /* Hide bottom glow on mobile to avoid overlay near the final form */\n  .home::after {\n    display: none;\n  }\n}\n\n.home-page #root {\n  margin-left: 0 !important;\n}\n\n.home-page aside,\n.home-page .sidenav---sidenav---_2tBP {\n  display: none !important;\n}\n\n.home h1,\n.home h2,\n.home h3,\n.home h4,\n.home h5 {\n  font-family: \"Bebas Neue\", \"Impact\", sans-serif;\n  margin: 0 0 12px;\n}\n\n.home p {\n  margin: 0 0 16px;\n  color: var(--home-ink-soft);\n}\n\n.home-container {\n  width: min(1440px, 99%);\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.home-section {\n  scroll-margin-top: var(--home-header-offset, 130px);\n  position: relative;\n  overflow: hidden;\n}\n\n.home-section::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(\n    circle at 20% 20%,\n    rgba(0, 102, 153, 0.45) 0%,\n    rgba(0, 102, 153, 0.3) 45%,\n    transparent 72%\n  );\n  opacity: 0;\n  transition: opacity 0.6s ease;\n  pointer-events: none;\n}\n\n.home .dark-gradient-section {\n  background: radial-gradient(\n    circle at top left,\n    var(--home-hero-grad-start) 0%,\n    #030628 35%,\n    var(--home-hero-grad-end) 100%\n  );\n}\n\n.home .btn {\n  border: none;\n  border-radius: 999px;\n  padding: 12px 22px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.home .btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);\n}\n\n.home .btn-primary {\n  background: #006699;\n  color: #fff;\n}\n\n.home .btn-outline {\n  background: transparent;\n  border: 1px solid #006699;\n  color: #006699;\n}\n\n.home .btn-ghost {\n  background: #fff;\n  border: 1px solid rgba(0, 102, 153, 0.35);\n  color: #006699;\n}\n\n.home-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: rgba(244, 251, 255, 0.92);\n  backdrop-filter: blur(14px);\n  z-index: 50;\n  border-bottom: 1px solid rgba(31, 193, 214, 0.22);\n}\n\n.home .header-inner {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 14px 0;\n}\n\n.home .brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.home .brand-mark {\n  width: 42px;\n  height: 42px;\n  border-radius: 14px;\n  background: var(--home-primary);\n  color: #fff;\n  display: grid;\n  place-items: center;\n  font-weight: 700;\n  overflow: hidden;\n}\n\n.home .desktop-logo {\n  display: block;\n  width: 190px;\n  height: 100%;\n  object-fit: contain;\n}\n\n.home .mobile-logo {\n  display: none;\n}\n.home .brand-text {\n  display: flex;\n  flex-direction: column;\n  font-size: 12px;\n}\n\n.home .brand-name {\n  font-weight: 700;\n  font-size: 16px;\n  color: var(--home-deep);\n}\n\n.home .brand-tag {\n  color: var(--home-ink-soft);\n}\n\n.home-nav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px;\n  justify-content: center;\n  font-size: 14px;\n  flex: 1 1 auto;\n}\n\n.home-nav a {\n  color: var(--home-ink);\n  text-decoration: none;\n}\n\n.home .header-cta {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.home .lang-switch {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n}\n\n.home .lang-toggle {\n  border: 1px solid rgba(31, 193, 214, 0.35);\n  background: rgba(255, 255, 255, 0.9);\n  color: var(--home-ink);\n  border-radius: 999px;\n  width: 38px;\n  height: 38px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.home .lang-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid rgba(31, 193, 214, 0.25);\n  box-shadow: 0 18px 40px rgba(6, 35, 53, 0.18);\n  padding: 8px;\n  display: grid;\n  gap: 6px;\n  z-index: 30;\n  min-width: 150px;\n}\n\n.home .lang-check {\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  font-weight: 600;\n  color: var(--home-ink);\n  cursor: pointer;\n}\n\n.home .lang-check:hover {\n  background: rgba(0, 102, 153, 0.08);\n}\n\n.home .lang-check input {\n  margin-left: auto;\n}\n\n.home .lang-flag {\n  width: 18px;\n  height: 14px;\n  border-radius: 3px;\n}\n\n.home .mobile-lang {\n  display: grid;\n  gap: 8px;\n  width: 100%;\n}\n\n.home .mobile-lang span {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--home-ink-soft);\n}\n\n.home .mobile-lang-actions {\n  display: grid;\n  gap: 8px;\n}\n\n.home .login-dropdown {\n  position: relative;\n  display: inline-flex;\n}\n\n.home .login-dropdown .dropdown-toggle {\n  min-width: 120px;\n}\n\n.home .dropdown-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  background: #ffffff;\n  border: 1px solid rgba(0, 102, 153, 0.2);\n  border-radius: 14px;\n  box-shadow: 0 16px 32px rgba(6, 35, 53, 0.18);\n  padding: 6px;\n  display: grid;\n  gap: 4px;\n  z-index: 70;\n  min-width: 180px;\n}\n\n.home .dropdown-menu button {\n  background: transparent;\n  border: none;\n  padding: 10px 12px;\n  border-radius: 10px;\n  text-align: left;\n  font-weight: 600;\n  color: #0b2a3c;\n  cursor: pointer;\n}\n\n.home .dropdown-menu button:hover {\n  background: rgba(0, 102, 153, 0.08);\n}\n\n.home .mobile-cta {\n  display: none;\n}\n\n.home .menu-toggle {\n  display: none;\n  background: #fff;\n  border: 1px solid rgba(0, 102, 153, 0.2);\n  border-radius: 12px;\n  padding: 0;\n  width: 46px;\n  height: 46px;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  z-index: 60;\n  box-shadow: none;\n  line-height: 0;\n  font-size: 0;\n  outline: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.home .menu-toggle svg {\n  width: 22px;\n  height: 22px;\n  color: var(--home-primary);\n  display: block;\n  pointer-events: none;\n}\n\n.home .menu-toggle:focus-visible {\n  outline: 2px solid rgba(0, 102, 153, 0.3);\n  outline-offset: 2px;\n}\n\n.home .menu-backdrop {\n  position: fixed;\n  inset: 0;\n  background: transparent; /* quitamos el overlay gris al abrir el men� m�vil */\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n  z-index: 40;\n}\n\n.home .menu-backdrop.show {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.home .hero {\n  padding: 40px 0 40px;\n  position: relative;\n  overflow: hidden;\n  min-height: auto;\n  display: flex;\n  align-items: center;\n}\n\n.home .hero-media {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.home .hero-bg-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  opacity: 0.7;\n  filter: saturate(1.05) contrast(1.05);\n}\n\n.home .hero-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.home .video-controls {\n  position: static;\n  display: flex;\n  gap: 8px;\n  z-index: 2;\n  justify-content: flex-end;\n  margin: 12px 0 16px;\n}\n\n.home .video-control {\n  background: #006699;\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  border-radius: 999px;\n  padding: 6px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 36px;\n  min-height: 30px;\n}\n\n.home .video-control:hover {\n  background: #005a86;\n}\n\n.home .video-control-icon {\n  font-size: 14px;\n  line-height: 1;\n}\n\n.home .visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.home .hero-overlay {\n  position: absolute;\n  inset: 0;\n  background: transparent;\n}\n\n.home .hero-grid {\n  position: relative;\n  z-index: 1;\n}\n\n.home .hero-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 36px;\n  align-items: center;\n}\n\n.home .eyebrow {\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--home-accent);\n}\n\n.hero-copy h1,\n.hero-copy p,\n.home .hero-copy .hero-sub {\n  color: #f8fdff;\n}\n\n.home .hero-copy .eyebrow {\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 13px;\n  letter-spacing: 0.2em;\n}\n\n.home .hero-copy .hero-sub {\n  color: rgba(244, 251, 255, 0.9);\n}\n\n.home .hero-sub {\n  font-size: 18px;\n  max-width: 560px;\n  line-height: 1.6;\n}\n\n.home .hero-copy h1 {\n  font-family: \"Manrope\", \"Segoe UI\", sans-serif;\n  font-size: clamp(28px, 5vw, 50px);\n  line-height: 1.06;\n  letter-spacing: -0.01em;\n  text-transform: none;\n}\n\n.home .hero-copy p {\n  font-size: 18px;\n}\n\n.home .hero-letter {\n  display: inline-block;\n  will-change: transform, opacity;\n}\n\n.home .hero-cta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin: 20px 0 18px;\n}\n\n.home .hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  background: rgba(7, 16, 26, 0.72);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  color: rgba(226, 240, 255, 0.92);\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  margin-bottom: 18px;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.28);\n}\n\n.home .hero-badge-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #2ad5a5;\n  box-shadow: 0 0 0 4px rgba(42, 213, 165, 0.18);\n}\n\n.home .hero-cta .btn-outline {\n  border-color: rgba(255, 255, 255, 0.32);\n  color: #eaf3ff;\n  background: rgba(9, 17, 26, 0.25);\n}\n\n.home .hero-cta .btn-ghost {\n  border-color: rgba(255, 255, 255, 0.16);\n  color: #eaf3ff;\n  background: rgba(9, 17, 26, 0.55);\n}\n\n.home .hero-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  cursor: none;\n}\n\n.home .hero-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  background: rgba(14, 26, 40, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: rgba(226, 240, 255, 0.9);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: default;\n}\n\n.home .hero-tag-emoji {\n  font-size: 14px;\n  line-height: 1;\n  cursor: default;\n}\n\n.home .hero-highlights {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.home .hero-highlights div {\n  background: #fff;\n  border-radius: 16px;\n  padding: 12px;\n  box-shadow: var(--home-shadow);\n}\n\n.home .widget-card {\n  border: 1px solid rgba(0, 102, 153, 0.28);\n  background: linear-gradient(180deg, rgba(0, 102, 153, 0.16) 0%, rgba(0, 102, 153, 0.04) 100%);\n  display: grid;\n  gap: 8px;\n}\n\n.home .widget-value {\n  font-size: 22px;\n  color: var(--home-primary);\n}\n\n.home .widget-label {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--home-ink-soft);\n}\n\n.home .widget-bar {\n  height: 6px;\n  background: rgba(0, 119, 182, 0.18);\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.home .widget-bar-fill {\n  display: block;\n  height: 100%;\n  width: 0%;\n  background: #006699;\n}\n\n.home .hero-visual .mockup {\n  background: #fff;\n  border-radius: var(--home-radius);\n  padding: 24px;\n  box-shadow: var(--home-shadow);\n  position: relative;\n}\n\n.home .mockup-map {\n  height: 300px;\n  border-radius: 18px;\n  background-color: #d8edf5;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.home .mockup-video {\n  background: #d8edf5;\n}\n\n.home .mockup-video-el {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  position: relative;\n  z-index: 1;\n}\n\n.home .video-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  border: none;\n  background: linear-gradient(135deg, rgba(0, 38, 68, 0.55), rgba(0, 102, 153, 0.35));\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.home .mockup-video:hover .video-overlay {\n  opacity: 0.92;\n  pointer-events: auto;\n}\n\n@media (hover: none) {\n  .home .video-overlay {\n    opacity: 0.92;\n    pointer-events: auto;\n  }\n}\n\n.home .map-route {\n  position: absolute;\n  inset: 20% 10% 20% 10%;\n  border: 2px dashed rgba(0, 102, 153, 0.3);\n  border-radius: 18px;\n}\n\n.home .map-dot {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: var(--home-accent);\n  position: absolute;\n  box-shadow: 0 0 0 6px rgba(46, 164, 177, 0.2);\n}\n\n.home .dot-1 {\n  top: 20%;\n  left: 25%;\n}\n\n.home .dot-2 {\n  top: 55%;\n  left: 45%;\n}\n\n.home .dot-3 {\n  top: 35%;\n  left: 70%;\n}\n\n.home .mockup-panels {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 16px;\n  margin: 18px 0;\n}\n\n.home .mockup-card {\n  background: #f3f8fb;\n  border-radius: 16px;\n  padding: 14px;\n  border: 1px solid rgba(0, 102, 153, 0.12);\n  font-size: 13px;\n}\n\n.home .mockup-card ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.home .mockup-card li {\n  margin-bottom: 6px;\n}\n\n.home .report-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.home .mockup-footer {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: var(--home-ink-soft);\n}\n\n.home .trust-bar {\n  padding: 28px 0;\n  background: #ffffff;\n}\n\n.home .trust-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 16px;\n}\n\n.home .trust-item {\n  background: linear-gradient(140deg, #ffffff 0%, #eaf7ff 100%);\n  border-radius: 16px;\n  padding: 16px;\n  border: 1px solid rgba(31, 193, 214, 0.2);\n}\n\n.home .trust-sub {\n  display: block;\n  font-size: 12px;\n  color: var(--home-ink-soft);\n  margin-top: 4px;\n}\n\n.home .trust-label {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--home-ink-soft);\n}\n\n.home .trust-feature {\n  margin-top: 32px;\n}\n\n.home .trust-feature .section-head h2 {\n  color: #0e3048;\n}\n\n.home .trust-feature .section-head p {\n  color: #2a4c63;\n  max-width: 820px;\n}\n\n.home .trust-feature-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n  margin-top: 18px;\n}\n\n.home .trust-feature-card {\n  background: #ffffff;\n  border-radius: 18px;\n  padding: 18px;\n  border: 1px solid rgba(0, 102, 153, 0.14);\n  box-shadow: 0 16px 34px rgba(7, 30, 52, 0.08);\n  display: grid;\n  gap: 10px;\n}\n\n.home .trust-feature-card h3 {\n  color: #0e3048;\n  margin-bottom: 0;\n}\n\n.home .trust-feature-card p {\n  color: #2a4c63;\n  margin: 0;\n}\n\n.home .trust-feature-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(0, 102, 153, 0.12);\n  display: grid;\n  place-items: center;\n  font-size: 20px;\n}\n\n.home .trust-flow {\n  margin-top: 18px;\n  background: #0a1433;\n  color: #eaf3ff;\n  border-radius: 999px;\n  padding: 10px 18px;\n  text-align: center;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  border: 1px solid rgba(0, 102, 153, 0.25);\n}\n\n.problem-solution,\n.modules,\n.how-it-works,\n.use-cases,\n.product-action,\n.security-evidence,\n.integrations,\n.security,\n.pricing,\n.faq,\n.home .final-cta {\n  padding: 72px 0;\n}\n\n.modules,\n.use-cases,\n.integrations,\n.pricing {\n  background: #ffffff;\n}\n\n.integrations {\n  background: #ffffff;\n}\n\n.integrations .home-container {\n  background: radial-gradient(\n    circle at top left,\n    var(--home-hero-grad-start) 0%,\n    #030628 35%,\n    var(--home-hero-grad-end) 100%\n  );\n  border-radius: 28px;\n  padding: 56px 48px;\n}\n\n.integrations .section-head h2 {\n  color: #ffffff;\n}\n\n.integrations .section-head p {\n  color: rgba(230, 243, 255, 0.88);\n}\n\n.clients {\n  background: #f7fbff;\n  padding: 72px 0;\n}\n\n.logo-marquee {\n  overflow: hidden;\n  margin: 20px 0 32px;\n}\n\n.logo-track {\n  display: flex;\n  gap: 36px;\n  animation: marquee 18s linear infinite;\n}\n\n.logo-track img {\n  height: 56px;\n  width: 120px;\n  object-fit: contain;\n  filter: none;\n}\n\n@keyframes marquee {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n.testimonials-grid {\n  display: none;\n}\n\n.testimonials-slider {\n  position: relative;\n  overflow: hidden;\n}\n\n.testimonial-track {\n  display: flex;\n  width: 100%;\n  transition: transform 0.6s ease;\n}\n\n.testimonial-slide {\n  min-width: 100%;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 14px;\n}\n\n.testimonial-card {\n  background: #fff;\n  border-radius: 18px;\n  padding: 16px;\n  border: 1px solid rgba(31, 193, 214, 0.18);\n  display: grid;\n  gap: 10px;\n}\n\n.testimonial-rating {\n  color: #f6b73c;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.rating-number {\n  color: #0e3048;\n}\n\n.testimonial-quote {\n  color: #1c3c52;\n  line-height: 1.5;\n}\n\n.testimonial-footer {\n  display: flex;\n  justify-content: space-between;\n  color: #4a6277;\n  font-weight: 600;\n}\n\n.testimonial-dots {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  margin-top: 10px;\n}\n\n.testimonial-dots .dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  border: 1px solid rgba(31, 193, 214, 0.5);\n  background: transparent;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease;\n}\n\n.testimonial-dots .dot.active {\n  background: #1fc1d6;\n  border-color: #1fc1d6;\n  transform: scale(1.1);\n}\n\n.home .faq {\n  background: #ffffff;\n  border-top: none;\n  margin-top: -2px; /* solapa con la secci�n anterior para ocultar la l�nea */\n}\n\n.how-it-works,\n.product-action,\n.home .security {\n  color: #e6f6ff;\n  margin-top: -1px; /* elimina l�nea entre secciones oscuras contiguas */\n}\n\n.how-it-works .section-head h2,\n.product-action .section-head h2,\n.home .security .section-head h2 {\n  color: #e6f6ff;\n}\n\n.how-it-works .section-head p,\n.product-action .section-head p,\n.home .security .section-head p {\n  color: #c5e4ff;\n}\n\n.how-it-works .btn,\n.product-action .btn,\n.home .security .btn {\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.35);\n}\n\n.how-it-works .btn-outline,\n.product-action .btn-outline,\n.home .security .btn-outline {\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.55);\n  background: transparent;\n}\n\n.how-it-works .btn-primary,\n.product-action .btn-primary,\n.home .security .btn-primary {\n  background: #1fc1d6;\n  color: #061827;\n  box-shadow: 0 10px 25px rgba(31, 193, 214, 0.25);\n}\n\n.home .section-head {\n  margin-bottom: 28px;\n}\n\n.home .problem-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n}\n\n.home .problem-card {\n  background: #fff;\n  border-radius: 18px;\n  padding: 18px;\n  border: 1px solid #eee2d2;\n}\n\n.home .solution-banner {\n  margin-top: 20px;\n  padding: 18px;\n  border-radius: 16px;\n  background: var(--home-primary);\n  color: #fff;\n}\n\n.home .module-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 18px;\n}\n\n.home .module-card {\n  background: #fff;\n  border-radius: 20px;\n  padding: 20px;\n  border: 1px solid rgba(31, 193, 214, 0.18);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.home .module-widget {\n  display: grid;\n  gap: 10px;\n  padding: 12px;\n  border-radius: 14px;\n  background: #e9f8ff;\n  border: 1px solid rgba(31, 193, 214, 0.2);\n}\n\n.home .module-bar {\n  height: 8px;\n  background: rgba(0, 119, 182, 0.2);\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.home .module-bar-fill {\n  display: block;\n  height: 100%;\n  width: 0%;\n  background: linear-gradient(90deg, var(--home-primary), var(--home-accent));\n}\n\n.home .module-card ul {\n  margin: 0;\n  padding-left: 18px;\n  color: var(--home-ink-soft);\n}\n\n.home .link-btn {\n  margin-top: auto;\n  background: none;\n  border: none;\n  color: var(--home-primary);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.home .steps-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n}\n\n.home .step-card {\n  background: #fff;\n  border-radius: 20px;\n  padding: 20px;\n  border: 1px solid rgba(31, 193, 214, 0.18);\n}\n\n.home .step-index {\n  font-weight: 700;\n  color: var(--home-accent);\n}\n\n.home .usecase-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 18px;\n}\n\n.home .usecase-card {\n  background: #fff;\n  border-radius: 20px;\n  padding: 20px;\n  border: 1px solid rgba(31, 193, 214, 0.18);\n  display: grid;\n  gap: 12px;\n}\n\n.home .usecase-row {\n  display: grid;\n  gap: 4px;\n  font-size: 14px;\n}\n\n.home .product-action .tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 24px;\n}\n\n.home .tab-btn {\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 999px;\n  padding: 8px 18px;\n  cursor: pointer;\n  font-weight: 600;\n  color: #e6f6ff;\n}\n\n.home .tab-btn.active {\n  background: #1fc1d6;\n  color: #061827;\n  border-color: transparent;\n  box-shadow: 0 8px 18px rgba(31, 193, 214, 0.32);\n}\n\n.home .tab-panel {\n  display: grid;\n  grid-template-columns: minmax(280px, 1fr) minmax(360px, 1.25fr);\n  gap: 24px;\n  align-items: start;\n}\n\n.home .product-action .tab-copy h3 {\n  color: #e6f6ff;\n}\n\n.home .product-action .tab-copy p,\n.home .product-action .tab-copy li {\n  color: #c5e4ff;\n}\n\n.home .product-action .btn-outline {\n  border-color: rgba(255, 255, 255, 0.5);\n  color: #fff;\n}\n\n.home .tab-panel ul {\n  padding-left: 18px;\n}\n\n.home .tab-visual {\n  display: grid;\n  gap: 16px;\n  align-content: start;\n}\n\n.home .panel-preview {\n  background: linear-gradient(135deg, #ffffff 0%, #eef7ff 50%, #e3f1ff 100%);\n  border-radius: 20px;\n  padding: 18px;\n  border: 1px solid rgba(31, 193, 214, 0.18);\n  width: 100%;\n}\n\n@media (max-width: 980px) {\n  .home .tab-panel {\n    grid-template-columns: 1fr;\n  }\n}\n\n.home .panel-header {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: #3b5368;\n  font-weight: 700;\n}\n\n.home .panel-body {\n  display: grid;\n  gap: 10px;\n  margin-top: 14px;\n  position: relative;\n}\n\n.home .panel-video {\n  width: 100%;\n  border-radius: 14px;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.08);\n  background: #000;\n  object-fit: cover;\n}\n\n.panel-skeleton {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  gap: 10px;\n  padding: 16px;\n  background: linear-gradient(135deg, #eef7ff 0%, #e3f1ff 100%);\n  border-radius: 14px;\n  z-index: 1;\n}\n\n.home .panel-line {\n  height: 12px;\n  background: #bcdaf5;\n  border-radius: 999px;\n}\n\n.home .panel-line.short {\n  width: 70%;\n}\n\n.home .panel-metrics {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 12px;\n}\n\n.home .panel-metrics div {\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 14px;\n  border: 1px solid rgba(31, 193, 214, 0.18);\n  text-align: center;\n  color: #0e3048;\n  font-weight: 700;\n}\n\n.home .panel-metrics div span {\n  display: block;\n  margin-top: 4px;\n  color: #1c3c52;\n  font-weight: 600;\n}\n\n.home .integration-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 18px;\n}\n\n.home .integration-card {\n  background: #fff;\n  border-radius: 20px;\n  padding: 20px;\n  border: 1px solid rgba(31, 193, 214, 0.18);\n}\n\n.home .integration-card ul {\n  padding-left: 18px;\n}\n\n.home .integrations-columns {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 22px;\n  margin-top: 26px;\n}\n\n.home .integration-panel {\n  background: #ffffff;\n  border-radius: 22px;\n  padding: 22px;\n  border: 1px solid rgba(14, 48, 72, 0.12);\n  box-shadow: 0 18px 40px rgba(10, 35, 55, 0.12);\n}\n\n.home .integration-panel h3 {\n  color: #0e3048;\n  margin-bottom: 14px;\n}\n\n.home .integration-panel ul {\n  margin: 12px 0 0;\n  padding-left: 20px;\n  color: #22455f;\n}\n\n.home .integration-panel li {\n  margin-bottom: 8px;\n}\n\n.home .integration-highlight {\n  background: linear-gradient(135deg, rgba(214, 245, 251, 0.9), rgba(232, 248, 255, 0.65));\n  border-radius: 16px;\n  padding: 14px 16px;\n  border: 1px solid rgba(31, 193, 214, 0.28);\n  margin-bottom: 16px;\n  color: #0c3348;\n  box-shadow: inset 0 0 24px rgba(31, 193, 214, 0.12);\n}\n\n.home .integration-highlight h4 {\n  margin-bottom: 6px;\n  color: #0e3048;\n  font-size: 16px;\n}\n\n.home .integration-highlight p {\n  margin: 0;\n  color: #24506b;\n}\n\n.home .security-evidence {\n  background: #f7fbff;\n  color: #0b2a3c;\n}\n\n.home .evidence-head h2 {\n  color: #0e3048;\n  font-weight: 700;\n}\n\n.home .evidence-head p {\n  color: #2e4453;\n  max-width: 860px;\n}\n\n.home .evidence-steps {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 18px;\n  padding: 12px;\n  border-radius: 18px;\n  background: #ffffff;\n  border: 1px solid rgba(0, 102, 153, 0.16);\n}\n\n.home .evidence-step {\n  background: #f2f7fb;\n  border: 1px solid rgba(0, 102, 153, 0.14);\n  color: #0e3048;\n  padding: 8px 14px;\n  border-radius: 999px;\n  font-weight: 600;\n  cursor: default;\n}\n\n.home .evidence-step.active {\n  background: linear-gradient(135deg, rgba(31, 193, 214, 0.25), rgba(31, 193, 214, 0.12));\n  border-color: rgba(31, 193, 214, 0.6);\n  color: #083044;\n}\n\n.home .evidence-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin-top: 12px;\n  color: #2e4a5f;\n  font-weight: 600;\n  font-size: 13px;\n  text-transform: lowercase;\n}\n\n.home .evidence-meta span {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.home .evidence-meta span::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #43c7da;\n  box-shadow: 0 0 8px rgba(67, 199, 218, 0.6);\n}\n\n.home .evidence-panels {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 18px;\n  margin-top: 18px;\n}\n\n.home .evidence-panel {\n  background: #ffffff;\n  border-radius: 18px;\n  padding: 18px;\n  border: 1px dashed rgba(0, 102, 153, 0.18);\n  box-shadow: 0 16px 32px rgba(6, 35, 53, 0.08);\n}\n\n.home .evidence-panel h4 {\n  color: #0e3048;\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n\n.home .evidence-placeholder {\n  display: block;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n  border-radius: 12px;\n  background: repeating-linear-gradient(\n    90deg,\n    rgba(206, 224, 238, 0.6),\n    rgba(206, 224, 238, 0.6) 10px,\n    rgba(224, 238, 248, 0.6) 10px,\n    rgba(224, 238, 248, 0.6) 20px\n  );\n  border: 1px solid rgba(0, 102, 153, 0.16);\n}\n\n.home .world-section {\n  padding: 88px 0 90px;\n  position: relative;\n  overflow: hidden;\n  color: #e6f6ff;\n  margin-bottom: -1px; /* solapa con la siguiente secci�n para evitar l�neas visibles */\n}\n\n.home .world-section::before {\n  content: \"\";\n  position: absolute;\n  width: 620px;\n  height: 620px;\n  border-radius: 50%;\n  right: -220px;\n  top: -220px;\n  background: radial-gradient(circle, rgba(31, 193, 214, 0.18), transparent 70%);\n  z-index: 0;\n}\n\n.home .world-layout {\n  display: flex;\n  gap: 18px;\n  align-items: flex-start;\n  justify-content: center;\n  flex-wrap: nowrap;\n}\n\n.home .world-right .section-head {\n  margin-bottom: 18px;\n}\n\n.home .world-right {\n  width: 100%;\n}\n\n.home .gps-animated-text {\n  max-width: 460px;\n}\n\n.home .world-panel {\n  position: relative;\n  z-index: 1;\n}\n\n.home .globe-stage {\n  position: relative;\n  flex: 0 0 560px;\n  min-width: 0;\n  transform-style: preserve-3d;\n  transition: transform 0.2s ease;\n  width: min(640px, 100%);\n}\n\n.home .globe-wrapper {\n  position: relative;\n  height: 460px;\n  min-height: 460px;\n  width: 100%;\n  border-radius: 0;\n  background: transparent;\n  overflow: visible;\n  transform-origin: center;\n  transform-style: preserve-3d;\n  display: flex;\n  align-items: center;  \n}\n\n.home .globe-canvas {\n  width: 100%;\n  height: 100%;\n  display: block;\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  background: transparent;\n}\n\n.home .globe-image {\n  width: auto;\n  height: 100%;\n  display: block;\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  border-radius: 24px;\n  align-self: center;\n}\n\n.home .globe-overlay {\n  position: absolute;\n  inset: 0;\n  background-image: none;\n  opacity: 0;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.home .globe-glow {\n  position: absolute;\n  inset: 0;\n  background: none;\n  pointer-events: none;\n  z-index: 3;\n}\n\n.home .globe-darken {\n  position: absolute;\n  inset: 0;\n  background: transparent;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.home .brand-orbit {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  z-index: 6;\n}\n\n.home .brand-chip {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  padding: 8px 12px;\n  border-radius: 999px;\n  background: rgba(7, 30, 46, 0.75);\n  border: 1px solid rgba(49, 200, 224, 0.45);\n  color: #e8f7ff;\n  font-weight: 600;\n  font-size: 12px;\n  letter-spacing: 0.02em;\n  box-shadow: 0 10px 20px rgba(2, 12, 22, 0.35);\n  backdrop-filter: blur(6px);\n  pointer-events: auto;\n  transition: transform 0.2s ease, opacity 0.2s ease, box-shadow 0.2s ease;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.home .brand-chip:hover {\n  box-shadow: 0 14px 26px rgba(2, 12, 22, 0.45);\n  border-color: rgba(53, 225, 242, 0.8);\n}\n\n.home .brand-chip img {\n  width: 48px;\n  height: 24px;\n  object-fit: contain;\n  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.35));\n}\n\n.home .brand-tooltip {\n  position: absolute;\n  left: 50%;\n  bottom: calc(100% + 10px);\n  transform: translate(-50%, 6px);\n  background: rgba(5, 18, 28, 0.95);\n  color: #e8f7ff;\n  padding: 8px 10px;\n  border-radius: 10px;\n  border: 1px solid rgba(49, 200, 224, 0.4);\n  font-size: 11px;\n  line-height: 1.2;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n  width: max-content;\n  max-width: 180px;\n  text-align: center;\n  z-index: 2;\n}\n\n.brand-chip.is-active .brand-tooltip,\n.home .brand-chip:hover .brand-tooltip {\n  opacity: 1;\n  transform: translate(-50%, 0);\n}\n\n.home .gps-animated-text {\n  flex: 0 0 340px;\n  max-width: 420px;\n  background: transparent;\n  border-radius: 0;\n  padding: 0;\n  border: none;\n  display: grid;\n  gap: 16px;\n  color: #e6f6ff;\n  box-shadow: none;\n}\n\n.home .gps-animated-text h3 {\n  margin: 0;\n  font-size: 28px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  line-height: 1.05;\n  color: #ffffff;\n  animation: headlinePulse 2.8s ease-in-out infinite;\n}\n\n.home .gps-animated-text p {\n  margin: 0;\n  color: rgba(230, 246, 255, 0.8);\n  font-size: 15px;\n  line-height: 1.5;\n  animation: copyFloat 6s ease-in-out infinite;\n}\n\n.home .gps-kicker {\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  font-size: 12px;\n  font-weight: 700;\n  color: #8fe9ff;\n  animation: kickerGlow 3.2s ease-in-out infinite;\n}\n\n.home .gps-pill-row {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-start;\n  list-style: disc;\n  list-style-position: outside;\n  padding-left: 18px;\n  margin: 0;\n}\n\n.home .gps-pill-row li {\n  background: transparent;\n  border: 0;\n  padding: 0;\n  border-radius: 0;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: left;\n}\n\n.home .world-right {\n  flex: 1 1 0;\n  display: grid;\n  gap: 16px;\n  min-width: 0;\n}\n\n.home .world-map-row {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  justify-content: space-around;\n  align-content: center;\n}\n\n.home .world-mobile-grid {\n  display: none;\n}\n\n.home .world-mobile-card {\n  display: grid;\n  grid-template-columns: 56px 1fr;\n  gap: 12px;\n  align-items: center;\n  padding: 14px 16px;\n  border-radius: 18px;\n  border: 1px solid rgba(31, 193, 214, 0.35);\n  background: rgba(7, 30, 46, 0.6);\n  color: #e6f6ff;\n}\n\n.home .world-mobile-card img {\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  object-fit: contain;\n  background: rgba(255, 255, 255, 0.92);\n  padding: 6px;\n}\n\n.home .world-mobile-card strong {\n  display: block;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.home .world-mobile-card span {\n  font-size: 12px;\n  color: rgba(230, 246, 255, 0.7);\n}\n\n@media (max-width: 1200px) {\n.home .world-layout {\n    gap: 20px;\n  }\n\n.home .gps-animated-text {\n    flex: 0 0 300px;\n    max-width: 320px;\n  }\n}\n\n@media (max-width: 1024px) {\n.home .world-layout {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n.home .world-map-row {\n    flex-direction: column;\n    align-items: center;\n  }\n\n.home .globe-stage {\n    width: auto;\n    max-width: 560px;\n    justify-content: center;\n    height: auto;\n    flex: 0 0 auto;\n  }\n\n.home .gps-animated-text {\n    max-width: 100%;\n    flex: 1 1 auto;\n    text-align: center;\n  }\n\n.home .gps-animated-text h3 {\n    font-size: 24px;\n  }\n\n.home .gps-animated-text p {\n    font-size: 14px;\n  }\n\n.home .gps-pill-row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    justify-items: center;\n  }\n\n.home .globe-wrapper {\n    height: 360px;\n  }\n\n.home .brand-orbit {\n    position: static;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    justify-content: center;\n    margin-top: 12px;\n  }\n\n.home .brand-chip {\n    position: static;\n    transform: none !important;\n  }\n}\n\n@media (max-width: 768px) {\n.home .world-map-row {\n    gap: 16px;\n  }\n\n.home .globe-wrapper {\n    height: clamp(220px, 55vw, 280px);\n    min-height: clamp(220px, 55vw, 280px);\n  }\n\n.home .globe-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n.home .gps-pill-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 576px) {\n.home .globe-wrapper {\n    height: clamp(200px, 60vw, 240px);\n    min-height: clamp(200px, 60vw, 240px);\n  }\n}\n\n.home .world-right {\n  width: 100%;\n}\n\n.home .world-left {\n  flex: 0 0 380px;\n  max-width: 420px;\n}\n\n.home .world-panel-right {\n  background: linear-gradient(160deg, #0b3e5f 0%, #07304b 60%, #062538 100%);\n  color: #fff;\n  border-radius: 28px;\n  padding: 24px;\n  border: 1px solid rgba(31, 193, 214, 0.35);\n  display: grid;\n  gap: 16px;\n}\n\n.home .world-panel-right p {\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.home .world-panel-right ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: 10px;\n}\n\n.home .world-panel-right li {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(31, 193, 214, 0.35);\n  padding: 10px 12px;\n  border-radius: 14px;\n  font-weight: 600;\n}\n\n.home .world-panel-right .btn-outline {\n  border-color: rgba(255, 255, 255, 0.5);\n  color: #fff;\n}\n\n.home .security-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.home .security-card {\n  background: #fff;\n  border-radius: 18px;\n  padding: 18px;\n  border: 1px solid rgba(31, 193, 214, 0.18);\n}\n\n.home .pricing-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 18px;\n}\n\n.home .price-card {\n  background: #f9fcff;\n  border-radius: 20px;\n  padding: 22px;\n  border: 1px solid rgba(31, 193, 214, 0.18);\n  display: grid;\n  gap: 12px;\n}\n\n.home .price-card.featured {\n  background: linear-gradient(135deg, #0a2a3f 0%, #0d5278 45%, #0b6c9c 100%);\n  color: #eaf6ff;\n}\n\n.price-card.featured p,\n.home .price-card.featured li {\n  color: #d8ecff;\n}\n\n.home .price-card .btn {\n  border: 1px solid var(--home-primary);\n  color: var(--home-primary);\n  background: transparent;\n}\n\n.home .price-card .btn-primary {\n  background: var(--home-primary);\n  color: #fff;\n  border-color: transparent;\n}\n\n.home .price-card.featured .btn-primary,\n.home .price-card.featured .btn {\n  background: rgba(255, 255, 255, 0.14);\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.35);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n}\n\n.home .price-card h3 {\n  color: #0e3048;\n}\n\n.home .price-card.featured h3 {\n  color: #ffffff;\n}\n\n.home .price-card.featured .price-tag {\n  color: #ffffff;\n  opacity: 0.96;\n}\n\n.home .price-card p,\n.home .price-card li {\n  color: #1c3c52;\n}\n\n.home .price-tag {\n  font-weight: 600;\n}\n\n.home .price-card ul {\n  padding-left: 18px;\n}\n\n.home .faq-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 18px;\n}\n\n.home .faq-item {\n  background: #fff;\n  border-radius: 18px;\n  padding: 18px;\n  border: 1px solid rgba(31, 193, 214, 0.18);\n}\n\n.home .final-cta {\n  background: #ffffff;\n}\n\n.home .final-cta::after {\n  /* Remove the generic section glow that covers inputs on small screens */\n  display: none;\n}\n\n.home-footer {\n  background: linear-gradient(135deg, #ffffff 0%, #f4fbff 60%, #e9f6ff 100%);\n  border-top: 1px solid rgba(31, 193, 214, 0.12);\n  padding: 26px 0;\n}\n\n.footer-inner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n  color: var(--home-ink-soft);\n}\n\n.footer-brand {\n  font-weight: 700;\n  color: var(--home-primary);\n}\n\n.footer-legal {\n  opacity: 0.85;\n}\n\n.footer-links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  justify-content: center;\n  color: var(--home-ink-soft);\n}\n\n.footer-links button {\n  background: none;\n  border: none;\n  padding: 0;\n  color: var(--home-ink-soft);\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.footer-links button:hover {\n  color: var(--home-primary);\n}\n\n@media (max-width: 640px) {\n  .footer-inner {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n\n.home .final-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 28px;\n  align-items: center;\n}\n\n.home .final-list {\n  display: grid;\n  gap: 8px;\n  font-weight: 600;\n}\n\n.home .final-form {\n  display: grid;\n  gap: 12px;\n  background: #fff;\n  padding: 22px;\n  border-radius: 20px;\n  border: 1px solid rgba(31, 193, 214, 0.18);\n}\n\n.home .final-form label {\n  display: grid;\n  gap: 6px;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.home .final-form input {\n  border-radius: 10px;\n  border: 1px solid rgba(31, 193, 214, 0.3);\n  padding: 10px;\n  font-size: 14px;\n}\n\n.home .final-form select {\n  border-radius: 10px;\n  border: 1px solid rgba(31, 193, 214, 0.3);\n  padding: 10px;\n  font-size: 14px;\n  background: #fff;\n  color: var(--home-ink);\n}\n\n.home .final-form textarea,\n.home .message-input {\n  width: 100%;\n  border-radius: 10px;\n  border: 1px solid rgba(31, 193, 214, 0.3);\n  padding: 10px 12px;\n  font-size: 14px;\n  font-family: inherit;\n  color: var(--home-ink);\n  background: #fff;\n  line-height: 1.4;\n  resize: vertical;\n  box-sizing: border-box;\n}\n\n.home .final-form input:focus,\n.home .final-form select:focus,\n.home .final-form textarea:focus,\n.home .message-input:focus,\n.home .phone-input:focus,\n.home .country-select__control--is-focused {\n  outline: none;\n  border-color: rgba(0, 102, 153, 0.55);\n  box-shadow: 0 0 0 3px rgba(0, 119, 182, 0.18);\n}\n\n.home .country-select {\n  font-size: 14px;\n}\n\n.home .country-select__control {\n  border-radius: 10px !important;\n  border: 1px solid rgba(31, 193, 214, 0.3) !important;\n  box-shadow: none !important;\n  min-height: 42px !important;\n  background: #fff !important;\n}\n\n.home .country-select__control:hover {\n  border-color: rgba(0, 102, 153, 0.55) !important;\n}\n\n.home .country-select__value-container {\n  padding: 2px 10px !important;\n}\n\n.home .country-select__single-value {\n  color: var(--home-ink) !important;\n  display: inline-flex !important;\n  align-items: center;\n  gap: 8px;\n}\n\n.home .country-select__menu {\n  border-radius: 12px !important;\n  overflow: hidden;\n  border: 1px solid rgba(31, 193, 214, 0.25);\n  box-shadow: 0 18px 40px rgba(6, 35, 53, 0.18);\n  z-index: 30;\n}\n\n.home .country-select__option {\n  font-size: 14px;\n}\n\n.home .country-select__indicator-separator {\n  display: none;\n}\n\n.home .country-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.home .country-flag {\n  width: 20px;\n  height: 16px;\n  border-radius: 3px;\n  box-shadow: 0 2px 6px rgba(6, 35, 53, 0.2);\n}\n\n.home .country-name {\n  color: var(--home-ink);\n}\n\n.home .phone-container {\n  width: 100%;\n}\n\n.home .phone-input {\n  width: 100% !important;\n  border-radius: 10px !important;\n  border: 1px solid rgba(31, 193, 214, 0.3) !important;\n  padding: 10px 12px 10px 48px !important;\n  font-size: 14px !important;\n  height: 42px !important;\n  box-shadow: none !important;\n}\n\n.home .phone-flag {\n  border-radius: 10px 0 0 10px !important;\n  border: 1px solid rgba(31, 193, 214, 0.3) !important;\n  background: #fff !important;\n}\n\n.home .phone-dropdown {\n  border-radius: 12px !important;\n  overflow: hidden;\n  border: 1px solid rgba(31, 193, 214, 0.25) !important;\n  box-shadow: 0 18px 40px rgba(6, 35, 53, 0.18) !important;\n}\n\n.home .anim-section,\n.home .anim-card,\n.home .anim-hero,\n.home .anim-visual {\n  will-change: transform, opacity;\n}\n\n.home .animate-up {\n  animation: fadeUp 0.7s ease both;\n}\n\n.home .card-animated {\n  position: relative;\n  overflow: hidden;\n  animation: cardRise 0.6s ease both;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n.home .card-animated::before {\n  content: none;\n}\n\n.home .card-animated::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    120deg,\n    transparent 0%,\n    rgba(0, 102, 153, 0.28) 45%,\n    rgba(0, 102, 153, 0.18) 70%,\n    transparent 100%\n  );\n  transform: translateX(-100%);\n  transition: transform 0.8s ease;\n}\n\n.home .card-animated:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 18px 30px rgba(0, 102, 153, 0.18);\n}\n\n.home .card-animated:hover::after {\n  transform: translateX(100%);\n}\n\n.home .float {\n  animation: float 5s ease-in-out infinite;\n}\n\n.home .floating-nav {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  display: grid;\n  gap: 12px;\n  z-index: 60;\n}\n\n.home .nav-btn {\n  border: 1px solid rgba(31, 193, 214, 0.3);\n  background: #fff;\n  color: var(--home-primary);\n  border-radius: 999px;\n  padding: 10px 18px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n}\n\n.home .nav-btn.icon {\n  width: 46px;\n  height: 46px;\n  padding: 0;\n  display: grid;\n  place-items: center;\n  font-size: 18px;\n}\n\n.home .nav-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);\n}\n\n.home .nav-btn.primary {\n  background: linear-gradient(135deg, var(--home-primary), var(--home-accent));\n  color: #fff;\n  border-color: transparent;\n}\n\n.home .module-grid > .card-animated:nth-child(1) { animation-delay: 0.05s; }\n.home .module-grid > .card-animated:nth-child(2) { animation-delay: 0.1s; }\n.home .module-grid > .card-animated:nth-child(3) { animation-delay: 0.15s; }\n.home .module-grid > .card-animated:nth-child(4) { animation-delay: 0.2s; }\n.home .module-grid > .card-animated:nth-child(5) { animation-delay: 0.25s; }\n.home .module-grid > .card-animated:nth-child(6) { animation-delay: 0.3s; }\n\n.home .usecase-grid > .card-animated:nth-child(odd),\n.home .pricing-grid > .card-animated:nth-child(odd),\n.home .faq-grid > .card-animated:nth-child(odd) {\n  animation-delay: 0.08s;\n}\n\n\n\n@keyframes fadeUp {\n  from {\n    opacity: 0;\n    transform: translateY(16px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes cardRise {\n  from {\n    opacity: 0;\n    transform: translateY(18px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n@keyframes drift {\n  0%, 100% {\n    transform: translate(0, 0);\n  }\n  50% {\n    transform: translate(40px, -20px);\n  }\n}\n\n@keyframes headlinePulse {\n  0%, 100% {\n    text-shadow: 0 0 0 rgba(143, 233, 255, 0);\n    transform: translateY(0);\n  }\n  50% {\n    text-shadow: 0 12px 30px rgba(143, 233, 255, 0.25);\n    transform: translateY(-2px);\n  }\n}\n\n@keyframes copyFloat {\n  0%, 100% {\n    transform: translateY(0);\n    opacity: 0.9;\n  }\n  50% {\n    transform: translateY(3px);\n    opacity: 1;\n  }\n}\n\n@keyframes kickerGlow {\n  0%, 100% {\n    opacity: 0.85;\n  }\n  50% {\n    opacity: 1;\n    text-shadow: 0 0 16px rgba(143, 233, 255, 0.45);\n  }\n}\n\n@media (max-width: 900px) {\n.home .globe-stage {\n    order: 1;\n  }\n\n.home .gps-animated-text {\n    order: 2;\n    max-width: 100%;\n  }\n\n.home .globe-stage {\n    display: block;\n    width: 100%;\n    max-width: 560px;\n    margin: 0 auto 18px;\n  }\n\n.home .world-section {\n    padding: 60px 0 72px;\n  }\n\n.home .world-layout {\n    gap: 24px;\n    align-items: center;\n  }\n\n.home .world-mobile-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 14px;\n    margin-top: 18px;\n  }\n\n.home .world-mobile-card {\n    grid-template-columns: 1fr;\n    justify-items: center;\n    text-align: center;\n    padding: 16px;\n  }\n\n.home .world-mobile-card div {\n    display: none;\n  }\n\n  .world-left,\n.home .world-right {\n    max-width: 100%;\n    flex: 1 1 auto;\n  }\n.home-header {\n    position: fixed;\n  }\n\n.home .header-inner {\n    grid-template-columns: auto 1fr auto;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 0;\n  }\n\n.home .menu-toggle {\n    justify-self: end;\n    margin-left: auto;\n  }\n\n.home .lang-switch {\n    display: none;\n  }\n\n.home {\n    padding-top: var(--home-header-offset, 90px);\n  }\n\n.home-nav {\n    position: fixed;\n    top: calc(var(--home-header-offset, 130px));\n    right: 16px;\n    left: 16px;\n    background: #fff;\n    border-radius: 18px;\n    padding: 18px 16px;\n    box-shadow: 0 24px 60px rgba(7, 36, 53, 0.18);\n    flex-direction: column;\n    gap: 14px;\n    align-items: flex-start;\n    opacity: 0;\n    transform: translateY(-10px);\n    pointer-events: none;\n    transition: opacity 0.2s ease, transform 0.2s ease;\n    z-index: 55;\n  }\n\n.home-nav.open {\n    opacity: 1;\n    transform: translateY(0);\n    pointer-events: auto;\n  }\n\n.home .header-cta {\n    display: none;\n  }\n\n.home .mobile-cta {\n    display: grid;\n    gap: 10px;\n    width: 100%;\n    padding-top: 4px;\n    border-top: 1px solid rgba(0, 102, 153, 0.12);\n    box-sizing: border-box;\n  }\n\n.home .mobile-cta .btn {\n    width: 100%;\n    justify-content: center;\n    box-sizing: border-box;\n    max-width: 100%;\n  }\n\n.home .menu-toggle {\n    display: inline-flex;\n  }\n\n.home .brand-text {\n    line-height: 1.2;\n  }\n\n.home .desktop-logo {\n    display: none;\n  }\n\n.home .mobile-logo {\n    width: 180px;\n    display: block;\n  }\n\n.home .hero-grid {\n    grid-template-columns: 1fr;\n  }\n\n.home .hero-cta {\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    align-items: center;\n  }\n\n.home .hero-visual .mockup {\n    padding: 18px;\n  }\n\n.home .mockup-panels {\n    grid-template-columns: 1fr;\n  }\n\n.home .hero-highlights {\n    grid-template-columns: repeat(2, minmax(120px, 1fr));\n  }\n\n.home .globe-wrapper {\n    height: 340px;\n  }\n\n.home .world-left {\n    order: 2;\n  }\n\n.home .floating-nav {\n    right: 16px;\n    bottom: 16px;\n    gap: 10px;\n  }\n}\n\n@media (max-width: 900px) {\n  .home .globe-wrapper {\n    height: auto;\n    min-height: 0;\n    aspect-ratio: 16 / 9;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .home .globe-image {\n    position: relative;\n    width: 100%;\n    height: auto;\n    max-height: 360px;\n    object-fit: contain;\n  }\n}\n\n@media (max-width: 680px) {\n.home .home-container {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n.home .header-cta {\n    width: 100%;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n\n.home .hero {\n    padding-top: 60px;\n  }\n\n.home .hero-highlights {\n    grid-template-columns: 1fr;\n  }\n\n.home .hero-cta {\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    padding: 0;\n    box-sizing: border-box;\n  }\n\n.home .globe-wrapper {\n    height: auto;\n    min-height: 0;\n    aspect-ratio: 16 / 9;\n  }\n\n.home .gps-pill-row {\n    grid-template-columns: 1fr;\n  }\n\n\n.home .hero-cta .btn {\n    width: 100%;\n    text-align: center;\n  }\n\n.home .hero-cta .btn {\n    max-width: 100%;\n    margin: 0;\n    box-sizing: border-box;\n  }\n}\n\n/* Splash screen */\n.splash-screen {\n  position: fixed;\n  inset: 0;\n  background: radial-gradient(circle at 30% 30%, #0a2a3f 0%, #051a2a 55%, #041424 100%);\n  display: grid;\n  place-items: center;\n  z-index: 9999;\n  animation: splashFade 0.7s ease 2.4s forwards;\n}\n\n.splash-logo {\n  width: min(360px, 70vw);\n  animation: splashIn 1.2s ease both;\n}\n\n@keyframes splashIn {\n  from {\n    opacity: 0;\n    transform: translateY(18px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes splashFade {\n  to {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
